/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root';
import { Route as VehiclesImport } from './routes/vehicles';
import { Route as TransactionsImport } from './routes/transactions';
import { Route as TransactionAdminImport } from './routes/transactionAdmin';
import { Route as ToolsImport } from './routes/tools';
import { Route as ToolFundRequestsImport } from './routes/toolFundRequests';
import { Route as ToolFundDashboardImport } from './routes/toolFundDashboard';
import { Route as ServicechannelOauthImport } from './routes/servicechannel-oauth';
import { Route as SearchImport } from './routes/search';
import { Route as RequisitionCatalogImport } from './routes/requisition-catalog';
import { Route as ReportsImport } from './routes/reports';
import { Route as QuickbooksOauthImport } from './routes/quickbooks-oauth';
import { Route as QuickbooksCustomerMappingImport } from './routes/quickbooks-customer-mapping';
import { Route as ProposalsImport } from './routes/proposals';
import { Route as ProjectResourcesImport } from './routes/projectResources';
import { Route as ProjectScheduleImport } from './routes/project-schedule';
import { Route as PermitAdminImport } from './routes/permitAdmin';
import { Route as PermissionsManagerImport } from './routes/permissionsManager';
import { Route as PerdiemImport } from './routes/perdiem';
import { Route as NewHireImport } from './routes/newHire';
import { Route as MyAccountImport } from './routes/my-account';
import { Route as MembershipReportImport } from './routes/membership-report';
import { Route as LogoutImport } from './routes/logout';
import { Route as LodgingRequestsImport } from './routes/lodgingRequests';
import { Route as LodgingAdminImport } from './routes/lodgingAdmin';
import { Route as JobsUnifiedImport } from './routes/jobs-unified';
import { Route as InventoryRequestsImport } from './routes/inventory-requests';
import { Route as HomeImport } from './routes/home';
import { Route as HelpDeskImport } from './routes/helpDesk';
import { Route as FormsDashboardImport } from './routes/formsDashboard';
import { Route as FirstcallsImport } from './routes/firstcalls';
import { Route as FirstCallsImport } from './routes/first-calls';
import { Route as DriverDashboardImport } from './routes/driverDashboard';
import { Route as DocumentsImport } from './routes/documents';
import { Route as DispatchNewImport } from './routes/dispatch-new';
import { Route as DispatchMapImport } from './routes/dispatch-map';
import { Route as DispatchImport } from './routes/dispatch';
import { Route as DepartmentsImport } from './routes/departments';
import { Route as DashboardHomeImport } from './routes/dashboard-home';
import { Route as CustomerServiceDashboardImport } from './routes/customer-service-dashboard';
import { Route as CreditCardsImport } from './routes/creditCards';
import { Route as CommercialServiceQueueImport } from './routes/commercial-service-queue';
import { Route as CallsPendingImport } from './routes/callsPending';
import { Route as CallWindowImport } from './routes/callWindow';
import { Route as BusinessesImport } from './routes/businesses';
import { Route as AppointmentSchedulerImport } from './routes/appointment-scheduler';
import { Route as AnalyticsImport } from './routes/analytics';
import { Route as AccountsPayableImport } from './routes/accountsPayable';
import { Route as AccountsImport } from './routes/accounts';
import { Route as IndexImport } from './routes/index';
import { Route as ToolLogIndexImport } from './routes/toolLog/index';
import { Route as ToolFundCatalogIndexImport } from './routes/toolFundCatalog/index';
import { Route as SpiffLogIndexImport } from './routes/spiffLog/index';
import { Route as ReportsIndexImport } from './routes/reports/index';
import { Route as PropertiesIndexImport } from './routes/properties/index';
import { Route as PayrollIndexImport } from './routes/payroll/index';
import { Route as NotesIndexImport } from './routes/notes/index';
import { Route as MembershipsIndexImport } from './routes/memberships/index';
import { Route as JobsIndexImport } from './routes/jobs/index';
import { Route as HrDashboardIndexImport } from './routes/hrDashboard/index';
import { Route as EmployeesIndexImport } from './routes/employees/index';
import { Route as CustomersIndexImport } from './routes/customers/index';
import { Route as CalendarIndexImport } from './routes/calendar/index';
import { Route as TravelEstimateJobNumberImport } from './routes/travel-estimate.$jobNumber';
import { Route as ToolsNitrogenImport } from './routes/tools.nitrogen';
import { Route as ToolLogToolLogOwnerIdImport } from './routes/toolLog/$toolLogOwnerId';
import { Route as ToolFundCatalogCatalogItemIdImport } from './routes/toolFundCatalog/$catalogItemId';
import { Route as TimesheetTimesheetOwnerIdImport } from './routes/timesheet.$timesheetOwnerId';
import { Route as TimeoffTimeOffRequestIdImport } from './routes/timeoff.$timeOffRequestId';
import { Route as TestPaymentLinkInvoiceIdImport } from './routes/test-payment-link.$invoiceId';
import { Route as SpiffLogAllocatorImport } from './routes/spiffLog/allocator';
import { Route as SpiffLogSpiffLogOwnerIdImport } from './routes/spiffLog/$spiffLogOwnerId';
import { Route as SoftphonePopupImport } from './routes/softphone/popup';
import { Route as SoftphoneOauthCallbackImport } from './routes/softphone/oauth-callback';
import { Route as SoftphoneNewJobImport } from './routes/softphone/new-job';
import { Route as ReportsTimeoffAuditImport } from './routes/reports.timeoff-audit';
import { Route as ReportsTimeOffImport } from './routes/reports/time-off';
import { Route as ReportsSystemInstallAnniversaryImport } from './routes/reports/system-install-anniversary';
import { Route as ReportsEmployeeOrgChartImport } from './routes/reports.employee-org-chart';
import { Route as ReportsCommDiffImport } from './routes/reports/comm-diff';
import { Route as ReimbursementsReimbursementOwnerIdImport } from './routes/reimbursements.$reimbursementOwnerId';
import { Route as ProposalJobDetailsCustomerTokenImport } from './routes/proposal-job-details-customer.$token';
import { Route as ProposalJobDetailsCustomerPreviewQuoteDocumentIdImport } from './routes/proposal-job-details-customer-preview.$quoteDocumentId';
import { Route as PropertyDetailsPropertyIdImport } from './routes/property-details.$propertyId';
import { Route as PropertiesPropertyIdImport } from './routes/properties/$propertyId';
import { Route as ProjectsEstimatesImport } from './routes/projects.estimates';
import { Route as ProjectResourcesProjectIdImport } from './routes/projectResources.$projectId';
import { Route as ProjectProjectIdImport } from './routes/project.$projectId';
import { Route as PermitAdminPermitGroupIdImport } from './routes/permitAdmin.$permitGroupId';
import { Route as PayrollManagePerdiemImport } from './routes/payroll/manage-perdiem';
import { Route as PaymentTokenImport } from './routes/payment.$token';
import { Route as NotesNotesIdsImport } from './routes/notes/$notesIds';
import { Route as MemoPreviewMemoIdImport } from './routes/memoPreview.$memoId';
import { Route as LodgingAssignmentLodgingAssignmentIdImport } from './routes/lodgingAssignment.$lodgingAssignmentId';
import { Route as LodgingAdminLodgingRequestIdImport } from './routes/lodgingAdmin.$lodgingRequestId';
import { Route as JobsJobIdImport } from './routes/jobs/$jobId';
import { Route as JobsAdminJobIdImport } from './routes/jobs-admin.$jobId';
import { Route as JobDetailsEventIdImport } from './routes/job-details.$eventId';
import { Route as HrDashboardPrIdImport } from './routes/hrDashboard/$prId';
import { Route as DocumentLinkImport } from './routes/document.$link';
import { Route as DepartmentsAddImport } from './routes/departments.add';
import { Route as DeclineProposalTokenImport } from './routes/decline-proposal.$token';
import { Route as CustomersAddImport } from './routes/customers/add';
import { Route as CustomersCustomerIdImport } from './routes/customers/$customerId';
import { Route as CustomerProposalTokenImport } from './routes/customer-proposal.$token';
import { Route as CustomerProposalPreviewQuoteDocumentIdImport } from './routes/customer-proposal-preview.$quoteDocumentId';
import { Route as CustomerDetailsCustomerIdImport } from './routes/customer-details.$customerId';
import { Route as CostReportJobNumberImport } from './routes/cost-report.$jobNumber';
import { Route as CardTokenImport } from './routes/card.$token';
import { Route as CalendarInitialCustomerIdImport } from './routes/calendar/$initialCustomerId';
import { Route as AdminServicechannelMappingsImport } from './routes/admin.servicechannel-mappings';
import { Route as AdminMembershipsCatalogImport } from './routes/admin.memberships-catalog';
import { Route as AdminFeatureFlagsImport } from './routes/admin.feature-flags';
import { Route as AdminEmailTasksImport } from './routes/admin.email-tasks';
import { Route as AcceptProposalTokenImport } from './routes/accept-proposal.$token';
import { Route as UserTimeOffUserIdImport } from './routes/user.time-off.$userId';
import { Route as StripeSuccessTokenImport } from './routes/stripe.success.$token';
import { Route as HrDashboardNewHireCreateImport } from './routes/hrDashboard/newHire.create';
import { Route as HrDashboardNewFireCreateImport } from './routes/hrDashboard/newFire.create';
import { Route as EmployeesItemsOptionsImport } from './routes/employees/items.options';
import { Route as DocumentsInvoicesInvoiceIdImport } from './routes/documents.invoices.$invoiceId';
import { Route as DepartmentsEditFunctionIdImport } from './routes/departments.edit.$functionId';
import { Route as PermitAdminPermitGroupIdPermitsPermitIdImport } from './routes/permitAdmin.$permitGroupId.permits.$permitId';
import { Route as HrDashboardNewHireEditNewHireIdImport } from './routes/hrDashboard/newHire.edit.$newHireId';
import { Route as HrDashboardNewFireEditUserIdImport } from './routes/hrDashboard/newFire.edit.$userId';
import { Route as CustomersUserIdPropertiesPropertyIdImport } from './routes/customers/$userId.properties.$propertyId';

// Create/Update Routes

const VehiclesRoute = VehiclesImport.update({
  id: '/vehicles',
  path: '/vehicles',
  getParentRoute: () => rootRoute,
} as any);

const TransactionsRoute = TransactionsImport.update({
  id: '/transactions',
  path: '/transactions',
  getParentRoute: () => rootRoute,
} as any);

const TransactionAdminRoute = TransactionAdminImport.update({
  id: '/transactionAdmin',
  path: '/transactionAdmin',
  getParentRoute: () => rootRoute,
} as any);

const ToolsRoute = ToolsImport.update({
  id: '/tools',
  path: '/tools',
  getParentRoute: () => rootRoute,
} as any);

const ToolFundRequestsRoute = ToolFundRequestsImport.update({
  id: '/toolFundRequests',
  path: '/toolFundRequests',
  getParentRoute: () => rootRoute,
} as any);

const ToolFundDashboardRoute = ToolFundDashboardImport.update({
  id: '/toolFundDashboard',
  path: '/toolFundDashboard',
  getParentRoute: () => rootRoute,
} as any);

const ServicechannelOauthRoute = ServicechannelOauthImport.update({
  id: '/servicechannel-oauth',
  path: '/servicechannel-oauth',
  getParentRoute: () => rootRoute,
} as any);

const SearchRoute = SearchImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => rootRoute,
} as any);

const RequisitionCatalogRoute = RequisitionCatalogImport.update({
  id: '/requisition-catalog',
  path: '/requisition-catalog',
  getParentRoute: () => rootRoute,
} as any);

const ReportsRoute = ReportsImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => rootRoute,
} as any);

const QuickbooksOauthRoute = QuickbooksOauthImport.update({
  id: '/quickbooks-oauth',
  path: '/quickbooks-oauth',
  getParentRoute: () => rootRoute,
} as any);

const QuickbooksCustomerMappingRoute = QuickbooksCustomerMappingImport.update({
  id: '/quickbooks-customer-mapping',
  path: '/quickbooks-customer-mapping',
  getParentRoute: () => rootRoute,
} as any);

const ProposalsRoute = ProposalsImport.update({
  id: '/proposals',
  path: '/proposals',
  getParentRoute: () => rootRoute,
} as any);

const ProjectResourcesRoute = ProjectResourcesImport.update({
  id: '/projectResources',
  path: '/projectResources',
  getParentRoute: () => rootRoute,
} as any);

const ProjectScheduleRoute = ProjectScheduleImport.update({
  id: '/project-schedule',
  path: '/project-schedule',
  getParentRoute: () => rootRoute,
} as any);

const PermitAdminRoute = PermitAdminImport.update({
  id: '/permitAdmin',
  path: '/permitAdmin',
  getParentRoute: () => rootRoute,
} as any);

const PermissionsManagerRoute = PermissionsManagerImport.update({
  id: '/permissionsManager',
  path: '/permissionsManager',
  getParentRoute: () => rootRoute,
} as any);

const PerdiemRoute = PerdiemImport.update({
  id: '/perdiem',
  path: '/perdiem',
  getParentRoute: () => rootRoute,
} as any);

const NewHireRoute = NewHireImport.update({
  id: '/newHire',
  path: '/newHire',
  getParentRoute: () => rootRoute,
} as any);

const MyAccountRoute = MyAccountImport.update({
  id: '/my-account',
  path: '/my-account',
  getParentRoute: () => rootRoute,
} as any);

const MembershipReportRoute = MembershipReportImport.update({
  id: '/membership-report',
  path: '/membership-report',
  getParentRoute: () => rootRoute,
} as any);

const LogoutRoute = LogoutImport.update({
  id: '/logout',
  path: '/logout',
  getParentRoute: () => rootRoute,
} as any);

const LodgingRequestsRoute = LodgingRequestsImport.update({
  id: '/lodgingRequests',
  path: '/lodgingRequests',
  getParentRoute: () => rootRoute,
} as any);

const LodgingAdminRoute = LodgingAdminImport.update({
  id: '/lodgingAdmin',
  path: '/lodgingAdmin',
  getParentRoute: () => rootRoute,
} as any);

const JobsUnifiedRoute = JobsUnifiedImport.update({
  id: '/jobs-unified',
  path: '/jobs-unified',
  getParentRoute: () => rootRoute,
} as any);

const InventoryRequestsRoute = InventoryRequestsImport.update({
  id: '/inventory-requests',
  path: '/inventory-requests',
  getParentRoute: () => rootRoute,
} as any);

const HomeRoute = HomeImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => rootRoute,
} as any);

const HelpDeskRoute = HelpDeskImport.update({
  id: '/helpDesk',
  path: '/helpDesk',
  getParentRoute: () => rootRoute,
} as any);

const FormsDashboardRoute = FormsDashboardImport.update({
  id: '/formsDashboard',
  path: '/formsDashboard',
  getParentRoute: () => rootRoute,
} as any);

const FirstcallsRoute = FirstcallsImport.update({
  id: '/firstcalls',
  path: '/firstcalls',
  getParentRoute: () => rootRoute,
} as any);

const FirstCallsRoute = FirstCallsImport.update({
  id: '/first-calls',
  path: '/first-calls',
  getParentRoute: () => rootRoute,
} as any);

const DriverDashboardRoute = DriverDashboardImport.update({
  id: '/driverDashboard',
  path: '/driverDashboard',
  getParentRoute: () => rootRoute,
} as any);

const DocumentsRoute = DocumentsImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => rootRoute,
} as any);

const DispatchNewRoute = DispatchNewImport.update({
  id: '/dispatch-new',
  path: '/dispatch-new',
  getParentRoute: () => rootRoute,
} as any);

const DispatchMapRoute = DispatchMapImport.update({
  id: '/dispatch-map',
  path: '/dispatch-map',
  getParentRoute: () => rootRoute,
} as any);

const DispatchRoute = DispatchImport.update({
  id: '/dispatch',
  path: '/dispatch',
  getParentRoute: () => rootRoute,
} as any);

const DepartmentsRoute = DepartmentsImport.update({
  id: '/departments',
  path: '/departments',
  getParentRoute: () => rootRoute,
} as any);

const DashboardHomeRoute = DashboardHomeImport.update({
  id: '/dashboard-home',
  path: '/dashboard-home',
  getParentRoute: () => rootRoute,
} as any);

const CustomerServiceDashboardRoute = CustomerServiceDashboardImport.update({
  id: '/customer-service-dashboard',
  path: '/customer-service-dashboard',
  getParentRoute: () => rootRoute,
} as any);

const CreditCardsRoute = CreditCardsImport.update({
  id: '/creditCards',
  path: '/creditCards',
  getParentRoute: () => rootRoute,
} as any);

const CommercialServiceQueueRoute = CommercialServiceQueueImport.update({
  id: '/commercial-service-queue',
  path: '/commercial-service-queue',
  getParentRoute: () => rootRoute,
} as any);

const CallsPendingRoute = CallsPendingImport.update({
  id: '/callsPending',
  path: '/callsPending',
  getParentRoute: () => rootRoute,
} as any);

const CallWindowRoute = CallWindowImport.update({
  id: '/callWindow',
  path: '/callWindow',
  getParentRoute: () => rootRoute,
} as any);

const BusinessesRoute = BusinessesImport.update({
  id: '/businesses',
  path: '/businesses',
  getParentRoute: () => rootRoute,
} as any);

const AppointmentSchedulerRoute = AppointmentSchedulerImport.update({
  id: '/appointment-scheduler',
  path: '/appointment-scheduler',
  getParentRoute: () => rootRoute,
} as any);

const AnalyticsRoute = AnalyticsImport.update({
  id: '/analytics',
  path: '/analytics',
  getParentRoute: () => rootRoute,
} as any);

const AccountsPayableRoute = AccountsPayableImport.update({
  id: '/accountsPayable',
  path: '/accountsPayable',
  getParentRoute: () => rootRoute,
} as any);

const AccountsRoute = AccountsImport.update({
  id: '/accounts',
  path: '/accounts',
  getParentRoute: () => rootRoute,
} as any);

const IndexRoute = IndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRoute,
} as any);

const ToolLogIndexRoute = ToolLogIndexImport.update({
  id: '/toolLog/',
  path: '/toolLog/',
  getParentRoute: () => rootRoute,
} as any);

const ToolFundCatalogIndexRoute = ToolFundCatalogIndexImport.update({
  id: '/toolFundCatalog/',
  path: '/toolFundCatalog/',
  getParentRoute: () => rootRoute,
} as any);

const SpiffLogIndexRoute = SpiffLogIndexImport.update({
  id: '/spiffLog/',
  path: '/spiffLog/',
  getParentRoute: () => rootRoute,
} as any);

const ReportsIndexRoute = ReportsIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ReportsRoute,
} as any);

const PropertiesIndexRoute = PropertiesIndexImport.update({
  id: '/properties/',
  path: '/properties/',
  getParentRoute: () => rootRoute,
} as any);

const PayrollIndexRoute = PayrollIndexImport.update({
  id: '/payroll/',
  path: '/payroll/',
  getParentRoute: () => rootRoute,
} as any);

const NotesIndexRoute = NotesIndexImport.update({
  id: '/notes/',
  path: '/notes/',
  getParentRoute: () => rootRoute,
} as any);

const MembershipsIndexRoute = MembershipsIndexImport.update({
  id: '/memberships/',
  path: '/memberships/',
  getParentRoute: () => rootRoute,
} as any);

const JobsIndexRoute = JobsIndexImport.update({
  id: '/jobs/',
  path: '/jobs/',
  getParentRoute: () => rootRoute,
} as any);

const HrDashboardIndexRoute = HrDashboardIndexImport.update({
  id: '/hrDashboard/',
  path: '/hrDashboard/',
  getParentRoute: () => rootRoute,
} as any);

const EmployeesIndexRoute = EmployeesIndexImport.update({
  id: '/employees/',
  path: '/employees/',
  getParentRoute: () => rootRoute,
} as any);

const CustomersIndexRoute = CustomersIndexImport.update({
  id: '/customers/',
  path: '/customers/',
  getParentRoute: () => rootRoute,
} as any);

const CalendarIndexRoute = CalendarIndexImport.update({
  id: '/calendar/',
  path: '/calendar/',
  getParentRoute: () => rootRoute,
} as any);

const TravelEstimateJobNumberRoute = TravelEstimateJobNumberImport.update({
  id: '/travel-estimate/$jobNumber',
  path: '/travel-estimate/$jobNumber',
  getParentRoute: () => rootRoute,
} as any);

const ToolsNitrogenRoute = ToolsNitrogenImport.update({
  id: '/nitrogen',
  path: '/nitrogen',
  getParentRoute: () => ToolsRoute,
} as any);

const ToolLogToolLogOwnerIdRoute = ToolLogToolLogOwnerIdImport.update({
  id: '/toolLog/$toolLogOwnerId',
  path: '/toolLog/$toolLogOwnerId',
  getParentRoute: () => rootRoute,
} as any);

const ToolFundCatalogCatalogItemIdRoute = ToolFundCatalogCatalogItemIdImport.update({
  id: '/toolFundCatalog/$catalogItemId',
  path: '/toolFundCatalog/$catalogItemId',
  getParentRoute: () => rootRoute,
} as any);

const TimesheetTimesheetOwnerIdRoute = TimesheetTimesheetOwnerIdImport.update({
  id: '/timesheet/$timesheetOwnerId',
  path: '/timesheet/$timesheetOwnerId',
  getParentRoute: () => rootRoute,
} as any);

const TimeoffTimeOffRequestIdRoute = TimeoffTimeOffRequestIdImport.update({
  id: '/timeoff/$timeOffRequestId',
  path: '/timeoff/$timeOffRequestId',
  getParentRoute: () => rootRoute,
} as any);

const TestPaymentLinkInvoiceIdRoute = TestPaymentLinkInvoiceIdImport.update({
  id: '/test-payment-link/$invoiceId',
  path: '/test-payment-link/$invoiceId',
  getParentRoute: () => rootRoute,
} as any);

const SpiffLogAllocatorRoute = SpiffLogAllocatorImport.update({
  id: '/spiffLog/allocator',
  path: '/spiffLog/allocator',
  getParentRoute: () => rootRoute,
} as any);

const SpiffLogSpiffLogOwnerIdRoute = SpiffLogSpiffLogOwnerIdImport.update({
  id: '/spiffLog/$spiffLogOwnerId',
  path: '/spiffLog/$spiffLogOwnerId',
  getParentRoute: () => rootRoute,
} as any);

const SoftphonePopupRoute = SoftphonePopupImport.update({
  id: '/softphone/popup',
  path: '/softphone/popup',
  getParentRoute: () => rootRoute,
} as any);

const SoftphoneOauthCallbackRoute = SoftphoneOauthCallbackImport.update({
  id: '/softphone/oauth-callback',
  path: '/softphone/oauth-callback',
  getParentRoute: () => rootRoute,
} as any);

const SoftphoneNewJobRoute = SoftphoneNewJobImport.update({
  id: '/softphone/new-job',
  path: '/softphone/new-job',
  getParentRoute: () => rootRoute,
} as any);

const ReportsTimeoffAuditRoute = ReportsTimeoffAuditImport.update({
  id: '/timeoff-audit',
  path: '/timeoff-audit',
  getParentRoute: () => ReportsRoute,
} as any);

const ReportsTimeOffRoute = ReportsTimeOffImport.update({
  id: '/time-off',
  path: '/time-off',
  getParentRoute: () => ReportsRoute,
} as any);

const ReportsSystemInstallAnniversaryRoute = ReportsSystemInstallAnniversaryImport.update({
  id: '/system-install-anniversary',
  path: '/system-install-anniversary',
  getParentRoute: () => ReportsRoute,
} as any);

const ReportsEmployeeOrgChartRoute = ReportsEmployeeOrgChartImport.update({
  id: '/employee-org-chart',
  path: '/employee-org-chart',
  getParentRoute: () => ReportsRoute,
} as any);

const ReportsCommDiffRoute = ReportsCommDiffImport.update({
  id: '/comm-diff',
  path: '/comm-diff',
  getParentRoute: () => ReportsRoute,
} as any);

const ReimbursementsReimbursementOwnerIdRoute = ReimbursementsReimbursementOwnerIdImport.update({
  id: '/reimbursements/$reimbursementOwnerId',
  path: '/reimbursements/$reimbursementOwnerId',
  getParentRoute: () => rootRoute,
} as any);

const ProposalJobDetailsCustomerTokenRoute = ProposalJobDetailsCustomerTokenImport.update({
  id: '/proposal-job-details-customer/$token',
  path: '/proposal-job-details-customer/$token',
  getParentRoute: () => rootRoute,
} as any);

const ProposalJobDetailsCustomerPreviewQuoteDocumentIdRoute =
  ProposalJobDetailsCustomerPreviewQuoteDocumentIdImport.update({
    id: '/proposal-job-details-customer-preview/$quoteDocumentId',
    path: '/proposal-job-details-customer-preview/$quoteDocumentId',
    getParentRoute: () => rootRoute,
  } as any);

const PropertyDetailsPropertyIdRoute = PropertyDetailsPropertyIdImport.update({
  id: '/property-details/$propertyId',
  path: '/property-details/$propertyId',
  getParentRoute: () => rootRoute,
} as any);

const PropertiesPropertyIdRoute = PropertiesPropertyIdImport.update({
  id: '/properties/$propertyId',
  path: '/properties/$propertyId',
  getParentRoute: () => rootRoute,
} as any);

const ProjectsEstimatesRoute = ProjectsEstimatesImport.update({
  id: '/projects/estimates',
  path: '/projects/estimates',
  getParentRoute: () => rootRoute,
} as any);

const ProjectResourcesProjectIdRoute = ProjectResourcesProjectIdImport.update({
  id: '/$projectId',
  path: '/$projectId',
  getParentRoute: () => ProjectResourcesRoute,
} as any);

const ProjectProjectIdRoute = ProjectProjectIdImport.update({
  id: '/project/$projectId',
  path: '/project/$projectId',
  getParentRoute: () => rootRoute,
} as any);

const PermitAdminPermitGroupIdRoute = PermitAdminPermitGroupIdImport.update({
  id: '/$permitGroupId',
  path: '/$permitGroupId',
  getParentRoute: () => PermitAdminRoute,
} as any);

const PayrollManagePerdiemRoute = PayrollManagePerdiemImport.update({
  id: '/payroll/manage-perdiem',
  path: '/payroll/manage-perdiem',
  getParentRoute: () => rootRoute,
} as any);

const PaymentTokenRoute = PaymentTokenImport.update({
  id: '/payment/$token',
  path: '/payment/$token',
  getParentRoute: () => rootRoute,
} as any);

const NotesNotesIdsRoute = NotesNotesIdsImport.update({
  id: '/notes/$notesIds',
  path: '/notes/$notesIds',
  getParentRoute: () => rootRoute,
} as any);

const MemoPreviewMemoIdRoute = MemoPreviewMemoIdImport.update({
  id: '/memoPreview/$memoId',
  path: '/memoPreview/$memoId',
  getParentRoute: () => rootRoute,
} as any);

const LodgingAssignmentLodgingAssignmentIdRoute = LodgingAssignmentLodgingAssignmentIdImport.update(
  {
    id: '/lodgingAssignment/$lodgingAssignmentId',
    path: '/lodgingAssignment/$lodgingAssignmentId',
    getParentRoute: () => rootRoute,
  } as any,
);

const LodgingAdminLodgingRequestIdRoute = LodgingAdminLodgingRequestIdImport.update({
  id: '/$lodgingRequestId',
  path: '/$lodgingRequestId',
  getParentRoute: () => LodgingAdminRoute,
} as any);

const JobsJobIdRoute = JobsJobIdImport.update({
  id: '/jobs/$jobId',
  path: '/jobs/$jobId',
  getParentRoute: () => rootRoute,
} as any);

const JobsAdminJobIdRoute = JobsAdminJobIdImport.update({
  id: '/jobs-admin/$jobId',
  path: '/jobs-admin/$jobId',
  getParentRoute: () => rootRoute,
} as any);

const JobDetailsEventIdRoute = JobDetailsEventIdImport.update({
  id: '/job-details/$eventId',
  path: '/job-details/$eventId',
  getParentRoute: () => rootRoute,
} as any);

const HrDashboardPrIdRoute = HrDashboardPrIdImport.update({
  id: '/hrDashboard/$prId',
  path: '/hrDashboard/$prId',
  getParentRoute: () => rootRoute,
} as any);

const DocumentLinkRoute = DocumentLinkImport.update({
  id: '/document/$link',
  path: '/document/$link',
  getParentRoute: () => rootRoute,
} as any);

const DepartmentsAddRoute = DepartmentsAddImport.update({
  id: '/add',
  path: '/add',
  getParentRoute: () => DepartmentsRoute,
} as any);

const DeclineProposalTokenRoute = DeclineProposalTokenImport.update({
  id: '/decline-proposal/$token',
  path: '/decline-proposal/$token',
  getParentRoute: () => rootRoute,
} as any);

const CustomersAddRoute = CustomersAddImport.update({
  id: '/customers/add',
  path: '/customers/add',
  getParentRoute: () => rootRoute,
} as any);

const CustomersCustomerIdRoute = CustomersCustomerIdImport.update({
  id: '/customers/$customerId',
  path: '/customers/$customerId',
  getParentRoute: () => rootRoute,
} as any);

const CustomerProposalTokenRoute = CustomerProposalTokenImport.update({
  id: '/customer-proposal/$token',
  path: '/customer-proposal/$token',
  getParentRoute: () => rootRoute,
} as any);

const CustomerProposalPreviewQuoteDocumentIdRoute =
  CustomerProposalPreviewQuoteDocumentIdImport.update({
    id: '/customer-proposal-preview/$quoteDocumentId',
    path: '/customer-proposal-preview/$quoteDocumentId',
    getParentRoute: () => rootRoute,
  } as any);

const CustomerDetailsCustomerIdRoute = CustomerDetailsCustomerIdImport.update({
  id: '/customer-details/$customerId',
  path: '/customer-details/$customerId',
  getParentRoute: () => rootRoute,
} as any);

const CostReportJobNumberRoute = CostReportJobNumberImport.update({
  id: '/cost-report/$jobNumber',
  path: '/cost-report/$jobNumber',
  getParentRoute: () => rootRoute,
} as any);

const CardTokenRoute = CardTokenImport.update({
  id: '/card/$token',
  path: '/card/$token',
  getParentRoute: () => rootRoute,
} as any);

const CalendarInitialCustomerIdRoute = CalendarInitialCustomerIdImport.update({
  id: '/calendar/$initialCustomerId',
  path: '/calendar/$initialCustomerId',
  getParentRoute: () => rootRoute,
} as any);

const AdminServicechannelMappingsRoute = AdminServicechannelMappingsImport.update({
  id: '/admin/servicechannel-mappings',
  path: '/admin/servicechannel-mappings',
  getParentRoute: () => rootRoute,
} as any);

const AdminMembershipsCatalogRoute = AdminMembershipsCatalogImport.update({
  id: '/admin/memberships-catalog',
  path: '/admin/memberships-catalog',
  getParentRoute: () => rootRoute,
} as any);

const AdminFeatureFlagsRoute = AdminFeatureFlagsImport.update({
  id: '/admin/feature-flags',
  path: '/admin/feature-flags',
  getParentRoute: () => rootRoute,
} as any);

const AdminEmailTasksRoute = AdminEmailTasksImport.update({
  id: '/admin/email-tasks',
  path: '/admin/email-tasks',
  getParentRoute: () => rootRoute,
} as any);

const AcceptProposalTokenRoute = AcceptProposalTokenImport.update({
  id: '/accept-proposal/$token',
  path: '/accept-proposal/$token',
  getParentRoute: () => rootRoute,
} as any);

const UserTimeOffUserIdRoute = UserTimeOffUserIdImport.update({
  id: '/user/time-off/$userId',
  path: '/user/time-off/$userId',
  getParentRoute: () => rootRoute,
} as any);

const StripeSuccessTokenRoute = StripeSuccessTokenImport.update({
  id: '/stripe/success/$token',
  path: '/stripe/success/$token',
  getParentRoute: () => rootRoute,
} as any);

const HrDashboardNewHireCreateRoute = HrDashboardNewHireCreateImport.update({
  id: '/hrDashboard/newHire/create',
  path: '/hrDashboard/newHire/create',
  getParentRoute: () => rootRoute,
} as any);

const HrDashboardNewFireCreateRoute = HrDashboardNewFireCreateImport.update({
  id: '/hrDashboard/newFire/create',
  path: '/hrDashboard/newFire/create',
  getParentRoute: () => rootRoute,
} as any);

const EmployeesItemsOptionsRoute = EmployeesItemsOptionsImport.update({
  id: '/employees/items/options',
  path: '/employees/items/options',
  getParentRoute: () => rootRoute,
} as any);

const DocumentsInvoicesInvoiceIdRoute = DocumentsInvoicesInvoiceIdImport.update({
  id: '/invoices/$invoiceId',
  path: '/invoices/$invoiceId',
  getParentRoute: () => DocumentsRoute,
} as any);

const DepartmentsEditFunctionIdRoute = DepartmentsEditFunctionIdImport.update({
  id: '/edit/$functionId',
  path: '/edit/$functionId',
  getParentRoute: () => DepartmentsRoute,
} as any);

const PermitAdminPermitGroupIdPermitsPermitIdRoute =
  PermitAdminPermitGroupIdPermitsPermitIdImport.update({
    id: '/permits/$permitId',
    path: '/permits/$permitId',
    getParentRoute: () => PermitAdminPermitGroupIdRoute,
  } as any);

const HrDashboardNewHireEditNewHireIdRoute = HrDashboardNewHireEditNewHireIdImport.update({
  id: '/hrDashboard/newHire/edit/$newHireId',
  path: '/hrDashboard/newHire/edit/$newHireId',
  getParentRoute: () => rootRoute,
} as any);

const HrDashboardNewFireEditUserIdRoute = HrDashboardNewFireEditUserIdImport.update({
  id: '/hrDashboard/newFire/edit/$userId',
  path: '/hrDashboard/newFire/edit/$userId',
  getParentRoute: () => rootRoute,
} as any);

const CustomersUserIdPropertiesPropertyIdRoute = CustomersUserIdPropertiesPropertyIdImport.update({
  id: '/customers/$userId/properties/$propertyId',
  path: '/customers/$userId/properties/$propertyId',
  getParentRoute: () => rootRoute,
} as any);

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/';
      path: '/';
      fullPath: '/';
      preLoaderRoute: typeof IndexImport;
      parentRoute: typeof rootRoute;
    };
    '/accounts': {
      id: '/accounts';
      path: '/accounts';
      fullPath: '/accounts';
      preLoaderRoute: typeof AccountsImport;
      parentRoute: typeof rootRoute;
    };
    '/accountsPayable': {
      id: '/accountsPayable';
      path: '/accountsPayable';
      fullPath: '/accountsPayable';
      preLoaderRoute: typeof AccountsPayableImport;
      parentRoute: typeof rootRoute;
    };
    '/analytics': {
      id: '/analytics';
      path: '/analytics';
      fullPath: '/analytics';
      preLoaderRoute: typeof AnalyticsImport;
      parentRoute: typeof rootRoute;
    };
    '/appointment-scheduler': {
      id: '/appointment-scheduler';
      path: '/appointment-scheduler';
      fullPath: '/appointment-scheduler';
      preLoaderRoute: typeof AppointmentSchedulerImport;
      parentRoute: typeof rootRoute;
    };
    '/businesses': {
      id: '/businesses';
      path: '/businesses';
      fullPath: '/businesses';
      preLoaderRoute: typeof BusinessesImport;
      parentRoute: typeof rootRoute;
    };
    '/callWindow': {
      id: '/callWindow';
      path: '/callWindow';
      fullPath: '/callWindow';
      preLoaderRoute: typeof CallWindowImport;
      parentRoute: typeof rootRoute;
    };
    '/callsPending': {
      id: '/callsPending';
      path: '/callsPending';
      fullPath: '/callsPending';
      preLoaderRoute: typeof CallsPendingImport;
      parentRoute: typeof rootRoute;
    };
    '/commercial-service-queue': {
      id: '/commercial-service-queue';
      path: '/commercial-service-queue';
      fullPath: '/commercial-service-queue';
      preLoaderRoute: typeof CommercialServiceQueueImport;
      parentRoute: typeof rootRoute;
    };
    '/creditCards': {
      id: '/creditCards';
      path: '/creditCards';
      fullPath: '/creditCards';
      preLoaderRoute: typeof CreditCardsImport;
      parentRoute: typeof rootRoute;
    };
    '/customer-service-dashboard': {
      id: '/customer-service-dashboard';
      path: '/customer-service-dashboard';
      fullPath: '/customer-service-dashboard';
      preLoaderRoute: typeof CustomerServiceDashboardImport;
      parentRoute: typeof rootRoute;
    };
    '/dashboard-home': {
      id: '/dashboard-home';
      path: '/dashboard-home';
      fullPath: '/dashboard-home';
      preLoaderRoute: typeof DashboardHomeImport;
      parentRoute: typeof rootRoute;
    };
    '/departments': {
      id: '/departments';
      path: '/departments';
      fullPath: '/departments';
      preLoaderRoute: typeof DepartmentsImport;
      parentRoute: typeof rootRoute;
    };
    '/dispatch': {
      id: '/dispatch';
      path: '/dispatch';
      fullPath: '/dispatch';
      preLoaderRoute: typeof DispatchImport;
      parentRoute: typeof rootRoute;
    };
    '/dispatch-map': {
      id: '/dispatch-map';
      path: '/dispatch-map';
      fullPath: '/dispatch-map';
      preLoaderRoute: typeof DispatchMapImport;
      parentRoute: typeof rootRoute;
    };
    '/dispatch-new': {
      id: '/dispatch-new';
      path: '/dispatch-new';
      fullPath: '/dispatch-new';
      preLoaderRoute: typeof DispatchNewImport;
      parentRoute: typeof rootRoute;
    };
    '/documents': {
      id: '/documents';
      path: '/documents';
      fullPath: '/documents';
      preLoaderRoute: typeof DocumentsImport;
      parentRoute: typeof rootRoute;
    };
    '/driverDashboard': {
      id: '/driverDashboard';
      path: '/driverDashboard';
      fullPath: '/driverDashboard';
      preLoaderRoute: typeof DriverDashboardImport;
      parentRoute: typeof rootRoute;
    };
    '/first-calls': {
      id: '/first-calls';
      path: '/first-calls';
      fullPath: '/first-calls';
      preLoaderRoute: typeof FirstCallsImport;
      parentRoute: typeof rootRoute;
    };
    '/firstcalls': {
      id: '/firstcalls';
      path: '/firstcalls';
      fullPath: '/firstcalls';
      preLoaderRoute: typeof FirstcallsImport;
      parentRoute: typeof rootRoute;
    };
    '/formsDashboard': {
      id: '/formsDashboard';
      path: '/formsDashboard';
      fullPath: '/formsDashboard';
      preLoaderRoute: typeof FormsDashboardImport;
      parentRoute: typeof rootRoute;
    };
    '/helpDesk': {
      id: '/helpDesk';
      path: '/helpDesk';
      fullPath: '/helpDesk';
      preLoaderRoute: typeof HelpDeskImport;
      parentRoute: typeof rootRoute;
    };
    '/home': {
      id: '/home';
      path: '/home';
      fullPath: '/home';
      preLoaderRoute: typeof HomeImport;
      parentRoute: typeof rootRoute;
    };
    '/inventory-requests': {
      id: '/inventory-requests';
      path: '/inventory-requests';
      fullPath: '/inventory-requests';
      preLoaderRoute: typeof InventoryRequestsImport;
      parentRoute: typeof rootRoute;
    };
    '/jobs-unified': {
      id: '/jobs-unified';
      path: '/jobs-unified';
      fullPath: '/jobs-unified';
      preLoaderRoute: typeof JobsUnifiedImport;
      parentRoute: typeof rootRoute;
    };
    '/lodgingAdmin': {
      id: '/lodgingAdmin';
      path: '/lodgingAdmin';
      fullPath: '/lodgingAdmin';
      preLoaderRoute: typeof LodgingAdminImport;
      parentRoute: typeof rootRoute;
    };
    '/lodgingRequests': {
      id: '/lodgingRequests';
      path: '/lodgingRequests';
      fullPath: '/lodgingRequests';
      preLoaderRoute: typeof LodgingRequestsImport;
      parentRoute: typeof rootRoute;
    };
    '/logout': {
      id: '/logout';
      path: '/logout';
      fullPath: '/logout';
      preLoaderRoute: typeof LogoutImport;
      parentRoute: typeof rootRoute;
    };
    '/membership-report': {
      id: '/membership-report';
      path: '/membership-report';
      fullPath: '/membership-report';
      preLoaderRoute: typeof MembershipReportImport;
      parentRoute: typeof rootRoute;
    };
    '/my-account': {
      id: '/my-account';
      path: '/my-account';
      fullPath: '/my-account';
      preLoaderRoute: typeof MyAccountImport;
      parentRoute: typeof rootRoute;
    };
    '/newHire': {
      id: '/newHire';
      path: '/newHire';
      fullPath: '/newHire';
      preLoaderRoute: typeof NewHireImport;
      parentRoute: typeof rootRoute;
    };
    '/perdiem': {
      id: '/perdiem';
      path: '/perdiem';
      fullPath: '/perdiem';
      preLoaderRoute: typeof PerdiemImport;
      parentRoute: typeof rootRoute;
    };
    '/permissionsManager': {
      id: '/permissionsManager';
      path: '/permissionsManager';
      fullPath: '/permissionsManager';
      preLoaderRoute: typeof PermissionsManagerImport;
      parentRoute: typeof rootRoute;
    };
    '/permitAdmin': {
      id: '/permitAdmin';
      path: '/permitAdmin';
      fullPath: '/permitAdmin';
      preLoaderRoute: typeof PermitAdminImport;
      parentRoute: typeof rootRoute;
    };
    '/project-schedule': {
      id: '/project-schedule';
      path: '/project-schedule';
      fullPath: '/project-schedule';
      preLoaderRoute: typeof ProjectScheduleImport;
      parentRoute: typeof rootRoute;
    };
    '/projectResources': {
      id: '/projectResources';
      path: '/projectResources';
      fullPath: '/projectResources';
      preLoaderRoute: typeof ProjectResourcesImport;
      parentRoute: typeof rootRoute;
    };
    '/proposals': {
      id: '/proposals';
      path: '/proposals';
      fullPath: '/proposals';
      preLoaderRoute: typeof ProposalsImport;
      parentRoute: typeof rootRoute;
    };
    '/quickbooks-customer-mapping': {
      id: '/quickbooks-customer-mapping';
      path: '/quickbooks-customer-mapping';
      fullPath: '/quickbooks-customer-mapping';
      preLoaderRoute: typeof QuickbooksCustomerMappingImport;
      parentRoute: typeof rootRoute;
    };
    '/quickbooks-oauth': {
      id: '/quickbooks-oauth';
      path: '/quickbooks-oauth';
      fullPath: '/quickbooks-oauth';
      preLoaderRoute: typeof QuickbooksOauthImport;
      parentRoute: typeof rootRoute;
    };
    '/reports': {
      id: '/reports';
      path: '/reports';
      fullPath: '/reports';
      preLoaderRoute: typeof ReportsImport;
      parentRoute: typeof rootRoute;
    };
    '/requisition-catalog': {
      id: '/requisition-catalog';
      path: '/requisition-catalog';
      fullPath: '/requisition-catalog';
      preLoaderRoute: typeof RequisitionCatalogImport;
      parentRoute: typeof rootRoute;
    };
    '/search': {
      id: '/search';
      path: '/search';
      fullPath: '/search';
      preLoaderRoute: typeof SearchImport;
      parentRoute: typeof rootRoute;
    };
    '/servicechannel-oauth': {
      id: '/servicechannel-oauth';
      path: '/servicechannel-oauth';
      fullPath: '/servicechannel-oauth';
      preLoaderRoute: typeof ServicechannelOauthImport;
      parentRoute: typeof rootRoute;
    };
    '/toolFundDashboard': {
      id: '/toolFundDashboard';
      path: '/toolFundDashboard';
      fullPath: '/toolFundDashboard';
      preLoaderRoute: typeof ToolFundDashboardImport;
      parentRoute: typeof rootRoute;
    };
    '/toolFundRequests': {
      id: '/toolFundRequests';
      path: '/toolFundRequests';
      fullPath: '/toolFundRequests';
      preLoaderRoute: typeof ToolFundRequestsImport;
      parentRoute: typeof rootRoute;
    };
    '/tools': {
      id: '/tools';
      path: '/tools';
      fullPath: '/tools';
      preLoaderRoute: typeof ToolsImport;
      parentRoute: typeof rootRoute;
    };
    '/transactionAdmin': {
      id: '/transactionAdmin';
      path: '/transactionAdmin';
      fullPath: '/transactionAdmin';
      preLoaderRoute: typeof TransactionAdminImport;
      parentRoute: typeof rootRoute;
    };
    '/transactions': {
      id: '/transactions';
      path: '/transactions';
      fullPath: '/transactions';
      preLoaderRoute: typeof TransactionsImport;
      parentRoute: typeof rootRoute;
    };
    '/vehicles': {
      id: '/vehicles';
      path: '/vehicles';
      fullPath: '/vehicles';
      preLoaderRoute: typeof VehiclesImport;
      parentRoute: typeof rootRoute;
    };
    '/accept-proposal/$token': {
      id: '/accept-proposal/$token';
      path: '/accept-proposal/$token';
      fullPath: '/accept-proposal/$token';
      preLoaderRoute: typeof AcceptProposalTokenImport;
      parentRoute: typeof rootRoute;
    };
    '/admin/email-tasks': {
      id: '/admin/email-tasks';
      path: '/admin/email-tasks';
      fullPath: '/admin/email-tasks';
      preLoaderRoute: typeof AdminEmailTasksImport;
      parentRoute: typeof rootRoute;
    };
    '/admin/feature-flags': {
      id: '/admin/feature-flags';
      path: '/admin/feature-flags';
      fullPath: '/admin/feature-flags';
      preLoaderRoute: typeof AdminFeatureFlagsImport;
      parentRoute: typeof rootRoute;
    };
    '/admin/memberships-catalog': {
      id: '/admin/memberships-catalog';
      path: '/admin/memberships-catalog';
      fullPath: '/admin/memberships-catalog';
      preLoaderRoute: typeof AdminMembershipsCatalogImport;
      parentRoute: typeof rootRoute;
    };
    '/admin/servicechannel-mappings': {
      id: '/admin/servicechannel-mappings';
      path: '/admin/servicechannel-mappings';
      fullPath: '/admin/servicechannel-mappings';
      preLoaderRoute: typeof AdminServicechannelMappingsImport;
      parentRoute: typeof rootRoute;
    };
    '/calendar/$initialCustomerId': {
      id: '/calendar/$initialCustomerId';
      path: '/calendar/$initialCustomerId';
      fullPath: '/calendar/$initialCustomerId';
      preLoaderRoute: typeof CalendarInitialCustomerIdImport;
      parentRoute: typeof rootRoute;
    };
    '/card/$token': {
      id: '/card/$token';
      path: '/card/$token';
      fullPath: '/card/$token';
      preLoaderRoute: typeof CardTokenImport;
      parentRoute: typeof rootRoute;
    };
    '/cost-report/$jobNumber': {
      id: '/cost-report/$jobNumber';
      path: '/cost-report/$jobNumber';
      fullPath: '/cost-report/$jobNumber';
      preLoaderRoute: typeof CostReportJobNumberImport;
      parentRoute: typeof rootRoute;
    };
    '/customer-details/$customerId': {
      id: '/customer-details/$customerId';
      path: '/customer-details/$customerId';
      fullPath: '/customer-details/$customerId';
      preLoaderRoute: typeof CustomerDetailsCustomerIdImport;
      parentRoute: typeof rootRoute;
    };
    '/customer-proposal-preview/$quoteDocumentId': {
      id: '/customer-proposal-preview/$quoteDocumentId';
      path: '/customer-proposal-preview/$quoteDocumentId';
      fullPath: '/customer-proposal-preview/$quoteDocumentId';
      preLoaderRoute: typeof CustomerProposalPreviewQuoteDocumentIdImport;
      parentRoute: typeof rootRoute;
    };
    '/customer-proposal/$token': {
      id: '/customer-proposal/$token';
      path: '/customer-proposal/$token';
      fullPath: '/customer-proposal/$token';
      preLoaderRoute: typeof CustomerProposalTokenImport;
      parentRoute: typeof rootRoute;
    };
    '/customers/$customerId': {
      id: '/customers/$customerId';
      path: '/customers/$customerId';
      fullPath: '/customers/$customerId';
      preLoaderRoute: typeof CustomersCustomerIdImport;
      parentRoute: typeof rootRoute;
    };
    '/customers/add': {
      id: '/customers/add';
      path: '/customers/add';
      fullPath: '/customers/add';
      preLoaderRoute: typeof CustomersAddImport;
      parentRoute: typeof rootRoute;
    };
    '/decline-proposal/$token': {
      id: '/decline-proposal/$token';
      path: '/decline-proposal/$token';
      fullPath: '/decline-proposal/$token';
      preLoaderRoute: typeof DeclineProposalTokenImport;
      parentRoute: typeof rootRoute;
    };
    '/departments/add': {
      id: '/departments/add';
      path: '/add';
      fullPath: '/departments/add';
      preLoaderRoute: typeof DepartmentsAddImport;
      parentRoute: typeof DepartmentsImport;
    };
    '/document/$link': {
      id: '/document/$link';
      path: '/document/$link';
      fullPath: '/document/$link';
      preLoaderRoute: typeof DocumentLinkImport;
      parentRoute: typeof rootRoute;
    };
    '/hrDashboard/$prId': {
      id: '/hrDashboard/$prId';
      path: '/hrDashboard/$prId';
      fullPath: '/hrDashboard/$prId';
      preLoaderRoute: typeof HrDashboardPrIdImport;
      parentRoute: typeof rootRoute;
    };
    '/job-details/$eventId': {
      id: '/job-details/$eventId';
      path: '/job-details/$eventId';
      fullPath: '/job-details/$eventId';
      preLoaderRoute: typeof JobDetailsEventIdImport;
      parentRoute: typeof rootRoute;
    };
    '/jobs-admin/$jobId': {
      id: '/jobs-admin/$jobId';
      path: '/jobs-admin/$jobId';
      fullPath: '/jobs-admin/$jobId';
      preLoaderRoute: typeof JobsAdminJobIdImport;
      parentRoute: typeof rootRoute;
    };
    '/jobs/$jobId': {
      id: '/jobs/$jobId';
      path: '/jobs/$jobId';
      fullPath: '/jobs/$jobId';
      preLoaderRoute: typeof JobsJobIdImport;
      parentRoute: typeof rootRoute;
    };
    '/lodgingAdmin/$lodgingRequestId': {
      id: '/lodgingAdmin/$lodgingRequestId';
      path: '/$lodgingRequestId';
      fullPath: '/lodgingAdmin/$lodgingRequestId';
      preLoaderRoute: typeof LodgingAdminLodgingRequestIdImport;
      parentRoute: typeof LodgingAdminImport;
    };
    '/lodgingAssignment/$lodgingAssignmentId': {
      id: '/lodgingAssignment/$lodgingAssignmentId';
      path: '/lodgingAssignment/$lodgingAssignmentId';
      fullPath: '/lodgingAssignment/$lodgingAssignmentId';
      preLoaderRoute: typeof LodgingAssignmentLodgingAssignmentIdImport;
      parentRoute: typeof rootRoute;
    };
    '/memoPreview/$memoId': {
      id: '/memoPreview/$memoId';
      path: '/memoPreview/$memoId';
      fullPath: '/memoPreview/$memoId';
      preLoaderRoute: typeof MemoPreviewMemoIdImport;
      parentRoute: typeof rootRoute;
    };
    '/notes/$notesIds': {
      id: '/notes/$notesIds';
      path: '/notes/$notesIds';
      fullPath: '/notes/$notesIds';
      preLoaderRoute: typeof NotesNotesIdsImport;
      parentRoute: typeof rootRoute;
    };
    '/payment/$token': {
      id: '/payment/$token';
      path: '/payment/$token';
      fullPath: '/payment/$token';
      preLoaderRoute: typeof PaymentTokenImport;
      parentRoute: typeof rootRoute;
    };
    '/payroll/manage-perdiem': {
      id: '/payroll/manage-perdiem';
      path: '/payroll/manage-perdiem';
      fullPath: '/payroll/manage-perdiem';
      preLoaderRoute: typeof PayrollManagePerdiemImport;
      parentRoute: typeof rootRoute;
    };
    '/permitAdmin/$permitGroupId': {
      id: '/permitAdmin/$permitGroupId';
      path: '/$permitGroupId';
      fullPath: '/permitAdmin/$permitGroupId';
      preLoaderRoute: typeof PermitAdminPermitGroupIdImport;
      parentRoute: typeof PermitAdminImport;
    };
    '/project/$projectId': {
      id: '/project/$projectId';
      path: '/project/$projectId';
      fullPath: '/project/$projectId';
      preLoaderRoute: typeof ProjectProjectIdImport;
      parentRoute: typeof rootRoute;
    };
    '/projectResources/$projectId': {
      id: '/projectResources/$projectId';
      path: '/$projectId';
      fullPath: '/projectResources/$projectId';
      preLoaderRoute: typeof ProjectResourcesProjectIdImport;
      parentRoute: typeof ProjectResourcesImport;
    };
    '/projects/estimates': {
      id: '/projects/estimates';
      path: '/projects/estimates';
      fullPath: '/projects/estimates';
      preLoaderRoute: typeof ProjectsEstimatesImport;
      parentRoute: typeof rootRoute;
    };
    '/properties/$propertyId': {
      id: '/properties/$propertyId';
      path: '/properties/$propertyId';
      fullPath: '/properties/$propertyId';
      preLoaderRoute: typeof PropertiesPropertyIdImport;
      parentRoute: typeof rootRoute;
    };
    '/property-details/$propertyId': {
      id: '/property-details/$propertyId';
      path: '/property-details/$propertyId';
      fullPath: '/property-details/$propertyId';
      preLoaderRoute: typeof PropertyDetailsPropertyIdImport;
      parentRoute: typeof rootRoute;
    };
    '/proposal-job-details-customer-preview/$quoteDocumentId': {
      id: '/proposal-job-details-customer-preview/$quoteDocumentId';
      path: '/proposal-job-details-customer-preview/$quoteDocumentId';
      fullPath: '/proposal-job-details-customer-preview/$quoteDocumentId';
      preLoaderRoute: typeof ProposalJobDetailsCustomerPreviewQuoteDocumentIdImport;
      parentRoute: typeof rootRoute;
    };
    '/proposal-job-details-customer/$token': {
      id: '/proposal-job-details-customer/$token';
      path: '/proposal-job-details-customer/$token';
      fullPath: '/proposal-job-details-customer/$token';
      preLoaderRoute: typeof ProposalJobDetailsCustomerTokenImport;
      parentRoute: typeof rootRoute;
    };
    '/reimbursements/$reimbursementOwnerId': {
      id: '/reimbursements/$reimbursementOwnerId';
      path: '/reimbursements/$reimbursementOwnerId';
      fullPath: '/reimbursements/$reimbursementOwnerId';
      preLoaderRoute: typeof ReimbursementsReimbursementOwnerIdImport;
      parentRoute: typeof rootRoute;
    };
    '/reports/comm-diff': {
      id: '/reports/comm-diff';
      path: '/comm-diff';
      fullPath: '/reports/comm-diff';
      preLoaderRoute: typeof ReportsCommDiffImport;
      parentRoute: typeof ReportsImport;
    };
    '/reports/employee-org-chart': {
      id: '/reports/employee-org-chart';
      path: '/employee-org-chart';
      fullPath: '/reports/employee-org-chart';
      preLoaderRoute: typeof ReportsEmployeeOrgChartImport;
      parentRoute: typeof ReportsImport;
    };
    '/reports/system-install-anniversary': {
      id: '/reports/system-install-anniversary';
      path: '/system-install-anniversary';
      fullPath: '/reports/system-install-anniversary';
      preLoaderRoute: typeof ReportsSystemInstallAnniversaryImport;
      parentRoute: typeof ReportsImport;
    };
    '/reports/time-off': {
      id: '/reports/time-off';
      path: '/time-off';
      fullPath: '/reports/time-off';
      preLoaderRoute: typeof ReportsTimeOffImport;
      parentRoute: typeof ReportsImport;
    };
    '/reports/timeoff-audit': {
      id: '/reports/timeoff-audit';
      path: '/timeoff-audit';
      fullPath: '/reports/timeoff-audit';
      preLoaderRoute: typeof ReportsTimeoffAuditImport;
      parentRoute: typeof ReportsImport;
    };
    '/softphone/new-job': {
      id: '/softphone/new-job';
      path: '/softphone/new-job';
      fullPath: '/softphone/new-job';
      preLoaderRoute: typeof SoftphoneNewJobImport;
      parentRoute: typeof rootRoute;
    };
    '/softphone/oauth-callback': {
      id: '/softphone/oauth-callback';
      path: '/softphone/oauth-callback';
      fullPath: '/softphone/oauth-callback';
      preLoaderRoute: typeof SoftphoneOauthCallbackImport;
      parentRoute: typeof rootRoute;
    };
    '/softphone/popup': {
      id: '/softphone/popup';
      path: '/softphone/popup';
      fullPath: '/softphone/popup';
      preLoaderRoute: typeof SoftphonePopupImport;
      parentRoute: typeof rootRoute;
    };
    '/spiffLog/$spiffLogOwnerId': {
      id: '/spiffLog/$spiffLogOwnerId';
      path: '/spiffLog/$spiffLogOwnerId';
      fullPath: '/spiffLog/$spiffLogOwnerId';
      preLoaderRoute: typeof SpiffLogSpiffLogOwnerIdImport;
      parentRoute: typeof rootRoute;
    };
    '/spiffLog/allocator': {
      id: '/spiffLog/allocator';
      path: '/spiffLog/allocator';
      fullPath: '/spiffLog/allocator';
      preLoaderRoute: typeof SpiffLogAllocatorImport;
      parentRoute: typeof rootRoute;
    };
    '/test-payment-link/$invoiceId': {
      id: '/test-payment-link/$invoiceId';
      path: '/test-payment-link/$invoiceId';
      fullPath: '/test-payment-link/$invoiceId';
      preLoaderRoute: typeof TestPaymentLinkInvoiceIdImport;
      parentRoute: typeof rootRoute;
    };
    '/timeoff/$timeOffRequestId': {
      id: '/timeoff/$timeOffRequestId';
      path: '/timeoff/$timeOffRequestId';
      fullPath: '/timeoff/$timeOffRequestId';
      preLoaderRoute: typeof TimeoffTimeOffRequestIdImport;
      parentRoute: typeof rootRoute;
    };
    '/timesheet/$timesheetOwnerId': {
      id: '/timesheet/$timesheetOwnerId';
      path: '/timesheet/$timesheetOwnerId';
      fullPath: '/timesheet/$timesheetOwnerId';
      preLoaderRoute: typeof TimesheetTimesheetOwnerIdImport;
      parentRoute: typeof rootRoute;
    };
    '/toolFundCatalog/$catalogItemId': {
      id: '/toolFundCatalog/$catalogItemId';
      path: '/toolFundCatalog/$catalogItemId';
      fullPath: '/toolFundCatalog/$catalogItemId';
      preLoaderRoute: typeof ToolFundCatalogCatalogItemIdImport;
      parentRoute: typeof rootRoute;
    };
    '/toolLog/$toolLogOwnerId': {
      id: '/toolLog/$toolLogOwnerId';
      path: '/toolLog/$toolLogOwnerId';
      fullPath: '/toolLog/$toolLogOwnerId';
      preLoaderRoute: typeof ToolLogToolLogOwnerIdImport;
      parentRoute: typeof rootRoute;
    };
    '/tools/nitrogen': {
      id: '/tools/nitrogen';
      path: '/nitrogen';
      fullPath: '/tools/nitrogen';
      preLoaderRoute: typeof ToolsNitrogenImport;
      parentRoute: typeof ToolsImport;
    };
    '/travel-estimate/$jobNumber': {
      id: '/travel-estimate/$jobNumber';
      path: '/travel-estimate/$jobNumber';
      fullPath: '/travel-estimate/$jobNumber';
      preLoaderRoute: typeof TravelEstimateJobNumberImport;
      parentRoute: typeof rootRoute;
    };
    '/calendar/': {
      id: '/calendar/';
      path: '/calendar';
      fullPath: '/calendar';
      preLoaderRoute: typeof CalendarIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/customers/': {
      id: '/customers/';
      path: '/customers';
      fullPath: '/customers';
      preLoaderRoute: typeof CustomersIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/employees/': {
      id: '/employees/';
      path: '/employees';
      fullPath: '/employees';
      preLoaderRoute: typeof EmployeesIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/hrDashboard/': {
      id: '/hrDashboard/';
      path: '/hrDashboard';
      fullPath: '/hrDashboard';
      preLoaderRoute: typeof HrDashboardIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/jobs/': {
      id: '/jobs/';
      path: '/jobs';
      fullPath: '/jobs';
      preLoaderRoute: typeof JobsIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/memberships/': {
      id: '/memberships/';
      path: '/memberships';
      fullPath: '/memberships';
      preLoaderRoute: typeof MembershipsIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/notes/': {
      id: '/notes/';
      path: '/notes';
      fullPath: '/notes';
      preLoaderRoute: typeof NotesIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/payroll/': {
      id: '/payroll/';
      path: '/payroll';
      fullPath: '/payroll';
      preLoaderRoute: typeof PayrollIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/properties/': {
      id: '/properties/';
      path: '/properties';
      fullPath: '/properties';
      preLoaderRoute: typeof PropertiesIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/reports/': {
      id: '/reports/';
      path: '/';
      fullPath: '/reports/';
      preLoaderRoute: typeof ReportsIndexImport;
      parentRoute: typeof ReportsImport;
    };
    '/spiffLog/': {
      id: '/spiffLog/';
      path: '/spiffLog';
      fullPath: '/spiffLog';
      preLoaderRoute: typeof SpiffLogIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/toolFundCatalog/': {
      id: '/toolFundCatalog/';
      path: '/toolFundCatalog';
      fullPath: '/toolFundCatalog';
      preLoaderRoute: typeof ToolFundCatalogIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/toolLog/': {
      id: '/toolLog/';
      path: '/toolLog';
      fullPath: '/toolLog';
      preLoaderRoute: typeof ToolLogIndexImport;
      parentRoute: typeof rootRoute;
    };
    '/departments/edit/$functionId': {
      id: '/departments/edit/$functionId';
      path: '/edit/$functionId';
      fullPath: '/departments/edit/$functionId';
      preLoaderRoute: typeof DepartmentsEditFunctionIdImport;
      parentRoute: typeof DepartmentsImport;
    };
    '/documents/invoices/$invoiceId': {
      id: '/documents/invoices/$invoiceId';
      path: '/invoices/$invoiceId';
      fullPath: '/documents/invoices/$invoiceId';
      preLoaderRoute: typeof DocumentsInvoicesInvoiceIdImport;
      parentRoute: typeof DocumentsImport;
    };
    '/employees/items/options': {
      id: '/employees/items/options';
      path: '/employees/items/options';
      fullPath: '/employees/items/options';
      preLoaderRoute: typeof EmployeesItemsOptionsImport;
      parentRoute: typeof rootRoute;
    };
    '/hrDashboard/newFire/create': {
      id: '/hrDashboard/newFire/create';
      path: '/hrDashboard/newFire/create';
      fullPath: '/hrDashboard/newFire/create';
      preLoaderRoute: typeof HrDashboardNewFireCreateImport;
      parentRoute: typeof rootRoute;
    };
    '/hrDashboard/newHire/create': {
      id: '/hrDashboard/newHire/create';
      path: '/hrDashboard/newHire/create';
      fullPath: '/hrDashboard/newHire/create';
      preLoaderRoute: typeof HrDashboardNewHireCreateImport;
      parentRoute: typeof rootRoute;
    };
    '/stripe/success/$token': {
      id: '/stripe/success/$token';
      path: '/stripe/success/$token';
      fullPath: '/stripe/success/$token';
      preLoaderRoute: typeof StripeSuccessTokenImport;
      parentRoute: typeof rootRoute;
    };
    '/user/time-off/$userId': {
      id: '/user/time-off/$userId';
      path: '/user/time-off/$userId';
      fullPath: '/user/time-off/$userId';
      preLoaderRoute: typeof UserTimeOffUserIdImport;
      parentRoute: typeof rootRoute;
    };
    '/customers/$userId/properties/$propertyId': {
      id: '/customers/$userId/properties/$propertyId';
      path: '/customers/$userId/properties/$propertyId';
      fullPath: '/customers/$userId/properties/$propertyId';
      preLoaderRoute: typeof CustomersUserIdPropertiesPropertyIdImport;
      parentRoute: typeof rootRoute;
    };
    '/hrDashboard/newFire/edit/$userId': {
      id: '/hrDashboard/newFire/edit/$userId';
      path: '/hrDashboard/newFire/edit/$userId';
      fullPath: '/hrDashboard/newFire/edit/$userId';
      preLoaderRoute: typeof HrDashboardNewFireEditUserIdImport;
      parentRoute: typeof rootRoute;
    };
    '/hrDashboard/newHire/edit/$newHireId': {
      id: '/hrDashboard/newHire/edit/$newHireId';
      path: '/hrDashboard/newHire/edit/$newHireId';
      fullPath: '/hrDashboard/newHire/edit/$newHireId';
      preLoaderRoute: typeof HrDashboardNewHireEditNewHireIdImport;
      parentRoute: typeof rootRoute;
    };
    '/permitAdmin/$permitGroupId/permits/$permitId': {
      id: '/permitAdmin/$permitGroupId/permits/$permitId';
      path: '/permits/$permitId';
      fullPath: '/permitAdmin/$permitGroupId/permits/$permitId';
      preLoaderRoute: typeof PermitAdminPermitGroupIdPermitsPermitIdImport;
      parentRoute: typeof PermitAdminPermitGroupIdImport;
    };
  }
}

// Create and export the route tree

interface DepartmentsRouteChildren {
  DepartmentsAddRoute: typeof DepartmentsAddRoute;
  DepartmentsEditFunctionIdRoute: typeof DepartmentsEditFunctionIdRoute;
}

const DepartmentsRouteChildren: DepartmentsRouteChildren = {
  DepartmentsAddRoute: DepartmentsAddRoute,
  DepartmentsEditFunctionIdRoute: DepartmentsEditFunctionIdRoute,
};

const DepartmentsRouteWithChildren = DepartmentsRoute._addFileChildren(DepartmentsRouteChildren);

interface DocumentsRouteChildren {
  DocumentsInvoicesInvoiceIdRoute: typeof DocumentsInvoicesInvoiceIdRoute;
}

const DocumentsRouteChildren: DocumentsRouteChildren = {
  DocumentsInvoicesInvoiceIdRoute: DocumentsInvoicesInvoiceIdRoute,
};

const DocumentsRouteWithChildren = DocumentsRoute._addFileChildren(DocumentsRouteChildren);

interface LodgingAdminRouteChildren {
  LodgingAdminLodgingRequestIdRoute: typeof LodgingAdminLodgingRequestIdRoute;
}

const LodgingAdminRouteChildren: LodgingAdminRouteChildren = {
  LodgingAdminLodgingRequestIdRoute: LodgingAdminLodgingRequestIdRoute,
};

const LodgingAdminRouteWithChildren = LodgingAdminRoute._addFileChildren(LodgingAdminRouteChildren);

interface PermitAdminPermitGroupIdRouteChildren {
  PermitAdminPermitGroupIdPermitsPermitIdRoute: typeof PermitAdminPermitGroupIdPermitsPermitIdRoute;
}

const PermitAdminPermitGroupIdRouteChildren: PermitAdminPermitGroupIdRouteChildren = {
  PermitAdminPermitGroupIdPermitsPermitIdRoute: PermitAdminPermitGroupIdPermitsPermitIdRoute,
};

const PermitAdminPermitGroupIdRouteWithChildren = PermitAdminPermitGroupIdRoute._addFileChildren(
  PermitAdminPermitGroupIdRouteChildren,
);

interface PermitAdminRouteChildren {
  PermitAdminPermitGroupIdRoute: typeof PermitAdminPermitGroupIdRouteWithChildren;
}

const PermitAdminRouteChildren: PermitAdminRouteChildren = {
  PermitAdminPermitGroupIdRoute: PermitAdminPermitGroupIdRouteWithChildren,
};

const PermitAdminRouteWithChildren = PermitAdminRoute._addFileChildren(PermitAdminRouteChildren);

interface ProjectResourcesRouteChildren {
  ProjectResourcesProjectIdRoute: typeof ProjectResourcesProjectIdRoute;
}

const ProjectResourcesRouteChildren: ProjectResourcesRouteChildren = {
  ProjectResourcesProjectIdRoute: ProjectResourcesProjectIdRoute,
};

const ProjectResourcesRouteWithChildren = ProjectResourcesRoute._addFileChildren(
  ProjectResourcesRouteChildren,
);

interface ReportsRouteChildren {
  ReportsCommDiffRoute: typeof ReportsCommDiffRoute;
  ReportsEmployeeOrgChartRoute: typeof ReportsEmployeeOrgChartRoute;
  ReportsSystemInstallAnniversaryRoute: typeof ReportsSystemInstallAnniversaryRoute;
  ReportsTimeOffRoute: typeof ReportsTimeOffRoute;
  ReportsTimeoffAuditRoute: typeof ReportsTimeoffAuditRoute;
  ReportsIndexRoute: typeof ReportsIndexRoute;
}

const ReportsRouteChildren: ReportsRouteChildren = {
  ReportsCommDiffRoute: ReportsCommDiffRoute,
  ReportsEmployeeOrgChartRoute: ReportsEmployeeOrgChartRoute,
  ReportsSystemInstallAnniversaryRoute: ReportsSystemInstallAnniversaryRoute,
  ReportsTimeOffRoute: ReportsTimeOffRoute,
  ReportsTimeoffAuditRoute: ReportsTimeoffAuditRoute,
  ReportsIndexRoute: ReportsIndexRoute,
};

const ReportsRouteWithChildren = ReportsRoute._addFileChildren(ReportsRouteChildren);

interface ToolsRouteChildren {
  ToolsNitrogenRoute: typeof ToolsNitrogenRoute;
}

const ToolsRouteChildren: ToolsRouteChildren = {
  ToolsNitrogenRoute: ToolsNitrogenRoute,
};

const ToolsRouteWithChildren = ToolsRoute._addFileChildren(ToolsRouteChildren);

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute;
  '/accounts': typeof AccountsRoute;
  '/accountsPayable': typeof AccountsPayableRoute;
  '/analytics': typeof AnalyticsRoute;
  '/appointment-scheduler': typeof AppointmentSchedulerRoute;
  '/businesses': typeof BusinessesRoute;
  '/callWindow': typeof CallWindowRoute;
  '/callsPending': typeof CallsPendingRoute;
  '/commercial-service-queue': typeof CommercialServiceQueueRoute;
  '/creditCards': typeof CreditCardsRoute;
  '/customer-service-dashboard': typeof CustomerServiceDashboardRoute;
  '/dashboard-home': typeof DashboardHomeRoute;
  '/departments': typeof DepartmentsRouteWithChildren;
  '/dispatch': typeof DispatchRoute;
  '/dispatch-map': typeof DispatchMapRoute;
  '/dispatch-new': typeof DispatchNewRoute;
  '/documents': typeof DocumentsRouteWithChildren;
  '/driverDashboard': typeof DriverDashboardRoute;
  '/first-calls': typeof FirstCallsRoute;
  '/firstcalls': typeof FirstcallsRoute;
  '/formsDashboard': typeof FormsDashboardRoute;
  '/helpDesk': typeof HelpDeskRoute;
  '/home': typeof HomeRoute;
  '/inventory-requests': typeof InventoryRequestsRoute;
  '/jobs-unified': typeof JobsUnifiedRoute;
  '/lodgingAdmin': typeof LodgingAdminRouteWithChildren;
  '/lodgingRequests': typeof LodgingRequestsRoute;
  '/logout': typeof LogoutRoute;
  '/membership-report': typeof MembershipReportRoute;
  '/my-account': typeof MyAccountRoute;
  '/newHire': typeof NewHireRoute;
  '/perdiem': typeof PerdiemRoute;
  '/permissionsManager': typeof PermissionsManagerRoute;
  '/permitAdmin': typeof PermitAdminRouteWithChildren;
  '/project-schedule': typeof ProjectScheduleRoute;
  '/projectResources': typeof ProjectResourcesRouteWithChildren;
  '/proposals': typeof ProposalsRoute;
  '/quickbooks-customer-mapping': typeof QuickbooksCustomerMappingRoute;
  '/quickbooks-oauth': typeof QuickbooksOauthRoute;
  '/reports': typeof ReportsRouteWithChildren;
  '/requisition-catalog': typeof RequisitionCatalogRoute;
  '/search': typeof SearchRoute;
  '/servicechannel-oauth': typeof ServicechannelOauthRoute;
  '/toolFundDashboard': typeof ToolFundDashboardRoute;
  '/toolFundRequests': typeof ToolFundRequestsRoute;
  '/tools': typeof ToolsRouteWithChildren;
  '/transactionAdmin': typeof TransactionAdminRoute;
  '/transactions': typeof TransactionsRoute;
  '/vehicles': typeof VehiclesRoute;
  '/accept-proposal/$token': typeof AcceptProposalTokenRoute;
  '/admin/email-tasks': typeof AdminEmailTasksRoute;
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute;
  '/admin/memberships-catalog': typeof AdminMembershipsCatalogRoute;
  '/admin/servicechannel-mappings': typeof AdminServicechannelMappingsRoute;
  '/calendar/$initialCustomerId': typeof CalendarInitialCustomerIdRoute;
  '/card/$token': typeof CardTokenRoute;
  '/cost-report/$jobNumber': typeof CostReportJobNumberRoute;
  '/customer-details/$customerId': typeof CustomerDetailsCustomerIdRoute;
  '/customer-proposal-preview/$quoteDocumentId': typeof CustomerProposalPreviewQuoteDocumentIdRoute;
  '/customer-proposal/$token': typeof CustomerProposalTokenRoute;
  '/customers/$customerId': typeof CustomersCustomerIdRoute;
  '/customers/add': typeof CustomersAddRoute;
  '/decline-proposal/$token': typeof DeclineProposalTokenRoute;
  '/departments/add': typeof DepartmentsAddRoute;
  '/document/$link': typeof DocumentLinkRoute;
  '/hrDashboard/$prId': typeof HrDashboardPrIdRoute;
  '/job-details/$eventId': typeof JobDetailsEventIdRoute;
  '/jobs-admin/$jobId': typeof JobsAdminJobIdRoute;
  '/jobs/$jobId': typeof JobsJobIdRoute;
  '/lodgingAdmin/$lodgingRequestId': typeof LodgingAdminLodgingRequestIdRoute;
  '/lodgingAssignment/$lodgingAssignmentId': typeof LodgingAssignmentLodgingAssignmentIdRoute;
  '/memoPreview/$memoId': typeof MemoPreviewMemoIdRoute;
  '/notes/$notesIds': typeof NotesNotesIdsRoute;
  '/payment/$token': typeof PaymentTokenRoute;
  '/payroll/manage-perdiem': typeof PayrollManagePerdiemRoute;
  '/permitAdmin/$permitGroupId': typeof PermitAdminPermitGroupIdRouteWithChildren;
  '/project/$projectId': typeof ProjectProjectIdRoute;
  '/projectResources/$projectId': typeof ProjectResourcesProjectIdRoute;
  '/projects/estimates': typeof ProjectsEstimatesRoute;
  '/properties/$propertyId': typeof PropertiesPropertyIdRoute;
  '/property-details/$propertyId': typeof PropertyDetailsPropertyIdRoute;
  '/proposal-job-details-customer-preview/$quoteDocumentId': typeof ProposalJobDetailsCustomerPreviewQuoteDocumentIdRoute;
  '/proposal-job-details-customer/$token': typeof ProposalJobDetailsCustomerTokenRoute;
  '/reimbursements/$reimbursementOwnerId': typeof ReimbursementsReimbursementOwnerIdRoute;
  '/reports/comm-diff': typeof ReportsCommDiffRoute;
  '/reports/employee-org-chart': typeof ReportsEmployeeOrgChartRoute;
  '/reports/system-install-anniversary': typeof ReportsSystemInstallAnniversaryRoute;
  '/reports/time-off': typeof ReportsTimeOffRoute;
  '/reports/timeoff-audit': typeof ReportsTimeoffAuditRoute;
  '/softphone/new-job': typeof SoftphoneNewJobRoute;
  '/softphone/oauth-callback': typeof SoftphoneOauthCallbackRoute;
  '/softphone/popup': typeof SoftphonePopupRoute;
  '/spiffLog/$spiffLogOwnerId': typeof SpiffLogSpiffLogOwnerIdRoute;
  '/spiffLog/allocator': typeof SpiffLogAllocatorRoute;
  '/test-payment-link/$invoiceId': typeof TestPaymentLinkInvoiceIdRoute;
  '/timeoff/$timeOffRequestId': typeof TimeoffTimeOffRequestIdRoute;
  '/timesheet/$timesheetOwnerId': typeof TimesheetTimesheetOwnerIdRoute;
  '/toolFundCatalog/$catalogItemId': typeof ToolFundCatalogCatalogItemIdRoute;
  '/toolLog/$toolLogOwnerId': typeof ToolLogToolLogOwnerIdRoute;
  '/tools/nitrogen': typeof ToolsNitrogenRoute;
  '/travel-estimate/$jobNumber': typeof TravelEstimateJobNumberRoute;
  '/calendar': typeof CalendarIndexRoute;
  '/customers': typeof CustomersIndexRoute;
  '/employees': typeof EmployeesIndexRoute;
  '/hrDashboard': typeof HrDashboardIndexRoute;
  '/jobs': typeof JobsIndexRoute;
  '/memberships': typeof MembershipsIndexRoute;
  '/notes': typeof NotesIndexRoute;
  '/payroll': typeof PayrollIndexRoute;
  '/properties': typeof PropertiesIndexRoute;
  '/reports/': typeof ReportsIndexRoute;
  '/spiffLog': typeof SpiffLogIndexRoute;
  '/toolFundCatalog': typeof ToolFundCatalogIndexRoute;
  '/toolLog': typeof ToolLogIndexRoute;
  '/departments/edit/$functionId': typeof DepartmentsEditFunctionIdRoute;
  '/documents/invoices/$invoiceId': typeof DocumentsInvoicesInvoiceIdRoute;
  '/employees/items/options': typeof EmployeesItemsOptionsRoute;
  '/hrDashboard/newFire/create': typeof HrDashboardNewFireCreateRoute;
  '/hrDashboard/newHire/create': typeof HrDashboardNewHireCreateRoute;
  '/stripe/success/$token': typeof StripeSuccessTokenRoute;
  '/user/time-off/$userId': typeof UserTimeOffUserIdRoute;
  '/customers/$userId/properties/$propertyId': typeof CustomersUserIdPropertiesPropertyIdRoute;
  '/hrDashboard/newFire/edit/$userId': typeof HrDashboardNewFireEditUserIdRoute;
  '/hrDashboard/newHire/edit/$newHireId': typeof HrDashboardNewHireEditNewHireIdRoute;
  '/permitAdmin/$permitGroupId/permits/$permitId': typeof PermitAdminPermitGroupIdPermitsPermitIdRoute;
}

export interface FileRoutesByTo {
  '/': typeof IndexRoute;
  '/accounts': typeof AccountsRoute;
  '/accountsPayable': typeof AccountsPayableRoute;
  '/analytics': typeof AnalyticsRoute;
  '/appointment-scheduler': typeof AppointmentSchedulerRoute;
  '/businesses': typeof BusinessesRoute;
  '/callWindow': typeof CallWindowRoute;
  '/callsPending': typeof CallsPendingRoute;
  '/commercial-service-queue': typeof CommercialServiceQueueRoute;
  '/creditCards': typeof CreditCardsRoute;
  '/customer-service-dashboard': typeof CustomerServiceDashboardRoute;
  '/dashboard-home': typeof DashboardHomeRoute;
  '/departments': typeof DepartmentsRouteWithChildren;
  '/dispatch': typeof DispatchRoute;
  '/dispatch-map': typeof DispatchMapRoute;
  '/dispatch-new': typeof DispatchNewRoute;
  '/documents': typeof DocumentsRouteWithChildren;
  '/driverDashboard': typeof DriverDashboardRoute;
  '/first-calls': typeof FirstCallsRoute;
  '/firstcalls': typeof FirstcallsRoute;
  '/formsDashboard': typeof FormsDashboardRoute;
  '/helpDesk': typeof HelpDeskRoute;
  '/home': typeof HomeRoute;
  '/inventory-requests': typeof InventoryRequestsRoute;
  '/jobs-unified': typeof JobsUnifiedRoute;
  '/lodgingAdmin': typeof LodgingAdminRouteWithChildren;
  '/lodgingRequests': typeof LodgingRequestsRoute;
  '/logout': typeof LogoutRoute;
  '/membership-report': typeof MembershipReportRoute;
  '/my-account': typeof MyAccountRoute;
  '/newHire': typeof NewHireRoute;
  '/perdiem': typeof PerdiemRoute;
  '/permissionsManager': typeof PermissionsManagerRoute;
  '/permitAdmin': typeof PermitAdminRouteWithChildren;
  '/project-schedule': typeof ProjectScheduleRoute;
  '/projectResources': typeof ProjectResourcesRouteWithChildren;
  '/proposals': typeof ProposalsRoute;
  '/quickbooks-customer-mapping': typeof QuickbooksCustomerMappingRoute;
  '/quickbooks-oauth': typeof QuickbooksOauthRoute;
  '/requisition-catalog': typeof RequisitionCatalogRoute;
  '/search': typeof SearchRoute;
  '/servicechannel-oauth': typeof ServicechannelOauthRoute;
  '/toolFundDashboard': typeof ToolFundDashboardRoute;
  '/toolFundRequests': typeof ToolFundRequestsRoute;
  '/tools': typeof ToolsRouteWithChildren;
  '/transactionAdmin': typeof TransactionAdminRoute;
  '/transactions': typeof TransactionsRoute;
  '/vehicles': typeof VehiclesRoute;
  '/accept-proposal/$token': typeof AcceptProposalTokenRoute;
  '/admin/email-tasks': typeof AdminEmailTasksRoute;
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute;
  '/admin/memberships-catalog': typeof AdminMembershipsCatalogRoute;
  '/admin/servicechannel-mappings': typeof AdminServicechannelMappingsRoute;
  '/calendar/$initialCustomerId': typeof CalendarInitialCustomerIdRoute;
  '/card/$token': typeof CardTokenRoute;
  '/cost-report/$jobNumber': typeof CostReportJobNumberRoute;
  '/customer-details/$customerId': typeof CustomerDetailsCustomerIdRoute;
  '/customer-proposal-preview/$quoteDocumentId': typeof CustomerProposalPreviewQuoteDocumentIdRoute;
  '/customer-proposal/$token': typeof CustomerProposalTokenRoute;
  '/customers/$customerId': typeof CustomersCustomerIdRoute;
  '/customers/add': typeof CustomersAddRoute;
  '/decline-proposal/$token': typeof DeclineProposalTokenRoute;
  '/departments/add': typeof DepartmentsAddRoute;
  '/document/$link': typeof DocumentLinkRoute;
  '/hrDashboard/$prId': typeof HrDashboardPrIdRoute;
  '/job-details/$eventId': typeof JobDetailsEventIdRoute;
  '/jobs-admin/$jobId': typeof JobsAdminJobIdRoute;
  '/jobs/$jobId': typeof JobsJobIdRoute;
  '/lodgingAdmin/$lodgingRequestId': typeof LodgingAdminLodgingRequestIdRoute;
  '/lodgingAssignment/$lodgingAssignmentId': typeof LodgingAssignmentLodgingAssignmentIdRoute;
  '/memoPreview/$memoId': typeof MemoPreviewMemoIdRoute;
  '/notes/$notesIds': typeof NotesNotesIdsRoute;
  '/payment/$token': typeof PaymentTokenRoute;
  '/payroll/manage-perdiem': typeof PayrollManagePerdiemRoute;
  '/permitAdmin/$permitGroupId': typeof PermitAdminPermitGroupIdRouteWithChildren;
  '/project/$projectId': typeof ProjectProjectIdRoute;
  '/projectResources/$projectId': typeof ProjectResourcesProjectIdRoute;
  '/projects/estimates': typeof ProjectsEstimatesRoute;
  '/properties/$propertyId': typeof PropertiesPropertyIdRoute;
  '/property-details/$propertyId': typeof PropertyDetailsPropertyIdRoute;
  '/proposal-job-details-customer-preview/$quoteDocumentId': typeof ProposalJobDetailsCustomerPreviewQuoteDocumentIdRoute;
  '/proposal-job-details-customer/$token': typeof ProposalJobDetailsCustomerTokenRoute;
  '/reimbursements/$reimbursementOwnerId': typeof ReimbursementsReimbursementOwnerIdRoute;
  '/reports/comm-diff': typeof ReportsCommDiffRoute;
  '/reports/employee-org-chart': typeof ReportsEmployeeOrgChartRoute;
  '/reports/system-install-anniversary': typeof ReportsSystemInstallAnniversaryRoute;
  '/reports/time-off': typeof ReportsTimeOffRoute;
  '/reports/timeoff-audit': typeof ReportsTimeoffAuditRoute;
  '/softphone/new-job': typeof SoftphoneNewJobRoute;
  '/softphone/oauth-callback': typeof SoftphoneOauthCallbackRoute;
  '/softphone/popup': typeof SoftphonePopupRoute;
  '/spiffLog/$spiffLogOwnerId': typeof SpiffLogSpiffLogOwnerIdRoute;
  '/spiffLog/allocator': typeof SpiffLogAllocatorRoute;
  '/test-payment-link/$invoiceId': typeof TestPaymentLinkInvoiceIdRoute;
  '/timeoff/$timeOffRequestId': typeof TimeoffTimeOffRequestIdRoute;
  '/timesheet/$timesheetOwnerId': typeof TimesheetTimesheetOwnerIdRoute;
  '/toolFundCatalog/$catalogItemId': typeof ToolFundCatalogCatalogItemIdRoute;
  '/toolLog/$toolLogOwnerId': typeof ToolLogToolLogOwnerIdRoute;
  '/tools/nitrogen': typeof ToolsNitrogenRoute;
  '/travel-estimate/$jobNumber': typeof TravelEstimateJobNumberRoute;
  '/calendar': typeof CalendarIndexRoute;
  '/customers': typeof CustomersIndexRoute;
  '/employees': typeof EmployeesIndexRoute;
  '/hrDashboard': typeof HrDashboardIndexRoute;
  '/jobs': typeof JobsIndexRoute;
  '/memberships': typeof MembershipsIndexRoute;
  '/notes': typeof NotesIndexRoute;
  '/payroll': typeof PayrollIndexRoute;
  '/properties': typeof PropertiesIndexRoute;
  '/reports': typeof ReportsIndexRoute;
  '/spiffLog': typeof SpiffLogIndexRoute;
  '/toolFundCatalog': typeof ToolFundCatalogIndexRoute;
  '/toolLog': typeof ToolLogIndexRoute;
  '/departments/edit/$functionId': typeof DepartmentsEditFunctionIdRoute;
  '/documents/invoices/$invoiceId': typeof DocumentsInvoicesInvoiceIdRoute;
  '/employees/items/options': typeof EmployeesItemsOptionsRoute;
  '/hrDashboard/newFire/create': typeof HrDashboardNewFireCreateRoute;
  '/hrDashboard/newHire/create': typeof HrDashboardNewHireCreateRoute;
  '/stripe/success/$token': typeof StripeSuccessTokenRoute;
  '/user/time-off/$userId': typeof UserTimeOffUserIdRoute;
  '/customers/$userId/properties/$propertyId': typeof CustomersUserIdPropertiesPropertyIdRoute;
  '/hrDashboard/newFire/edit/$userId': typeof HrDashboardNewFireEditUserIdRoute;
  '/hrDashboard/newHire/edit/$newHireId': typeof HrDashboardNewHireEditNewHireIdRoute;
  '/permitAdmin/$permitGroupId/permits/$permitId': typeof PermitAdminPermitGroupIdPermitsPermitIdRoute;
}

export interface FileRoutesById {
  __root__: typeof rootRoute;
  '/': typeof IndexRoute;
  '/accounts': typeof AccountsRoute;
  '/accountsPayable': typeof AccountsPayableRoute;
  '/analytics': typeof AnalyticsRoute;
  '/appointment-scheduler': typeof AppointmentSchedulerRoute;
  '/businesses': typeof BusinessesRoute;
  '/callWindow': typeof CallWindowRoute;
  '/callsPending': typeof CallsPendingRoute;
  '/commercial-service-queue': typeof CommercialServiceQueueRoute;
  '/creditCards': typeof CreditCardsRoute;
  '/customer-service-dashboard': typeof CustomerServiceDashboardRoute;
  '/dashboard-home': typeof DashboardHomeRoute;
  '/departments': typeof DepartmentsRouteWithChildren;
  '/dispatch': typeof DispatchRoute;
  '/dispatch-map': typeof DispatchMapRoute;
  '/dispatch-new': typeof DispatchNewRoute;
  '/documents': typeof DocumentsRouteWithChildren;
  '/driverDashboard': typeof DriverDashboardRoute;
  '/first-calls': typeof FirstCallsRoute;
  '/firstcalls': typeof FirstcallsRoute;
  '/formsDashboard': typeof FormsDashboardRoute;
  '/helpDesk': typeof HelpDeskRoute;
  '/home': typeof HomeRoute;
  '/inventory-requests': typeof InventoryRequestsRoute;
  '/jobs-unified': typeof JobsUnifiedRoute;
  '/lodgingAdmin': typeof LodgingAdminRouteWithChildren;
  '/lodgingRequests': typeof LodgingRequestsRoute;
  '/logout': typeof LogoutRoute;
  '/membership-report': typeof MembershipReportRoute;
  '/my-account': typeof MyAccountRoute;
  '/newHire': typeof NewHireRoute;
  '/perdiem': typeof PerdiemRoute;
  '/permissionsManager': typeof PermissionsManagerRoute;
  '/permitAdmin': typeof PermitAdminRouteWithChildren;
  '/project-schedule': typeof ProjectScheduleRoute;
  '/projectResources': typeof ProjectResourcesRouteWithChildren;
  '/proposals': typeof ProposalsRoute;
  '/quickbooks-customer-mapping': typeof QuickbooksCustomerMappingRoute;
  '/quickbooks-oauth': typeof QuickbooksOauthRoute;
  '/reports': typeof ReportsRouteWithChildren;
  '/requisition-catalog': typeof RequisitionCatalogRoute;
  '/search': typeof SearchRoute;
  '/servicechannel-oauth': typeof ServicechannelOauthRoute;
  '/toolFundDashboard': typeof ToolFundDashboardRoute;
  '/toolFundRequests': typeof ToolFundRequestsRoute;
  '/tools': typeof ToolsRouteWithChildren;
  '/transactionAdmin': typeof TransactionAdminRoute;
  '/transactions': typeof TransactionsRoute;
  '/vehicles': typeof VehiclesRoute;
  '/accept-proposal/$token': typeof AcceptProposalTokenRoute;
  '/admin/email-tasks': typeof AdminEmailTasksRoute;
  '/admin/feature-flags': typeof AdminFeatureFlagsRoute;
  '/admin/memberships-catalog': typeof AdminMembershipsCatalogRoute;
  '/admin/servicechannel-mappings': typeof AdminServicechannelMappingsRoute;
  '/calendar/$initialCustomerId': typeof CalendarInitialCustomerIdRoute;
  '/card/$token': typeof CardTokenRoute;
  '/cost-report/$jobNumber': typeof CostReportJobNumberRoute;
  '/customer-details/$customerId': typeof CustomerDetailsCustomerIdRoute;
  '/customer-proposal-preview/$quoteDocumentId': typeof CustomerProposalPreviewQuoteDocumentIdRoute;
  '/customer-proposal/$token': typeof CustomerProposalTokenRoute;
  '/customers/$customerId': typeof CustomersCustomerIdRoute;
  '/customers/add': typeof CustomersAddRoute;
  '/decline-proposal/$token': typeof DeclineProposalTokenRoute;
  '/departments/add': typeof DepartmentsAddRoute;
  '/document/$link': typeof DocumentLinkRoute;
  '/hrDashboard/$prId': typeof HrDashboardPrIdRoute;
  '/job-details/$eventId': typeof JobDetailsEventIdRoute;
  '/jobs-admin/$jobId': typeof JobsAdminJobIdRoute;
  '/jobs/$jobId': typeof JobsJobIdRoute;
  '/lodgingAdmin/$lodgingRequestId': typeof LodgingAdminLodgingRequestIdRoute;
  '/lodgingAssignment/$lodgingAssignmentId': typeof LodgingAssignmentLodgingAssignmentIdRoute;
  '/memoPreview/$memoId': typeof MemoPreviewMemoIdRoute;
  '/notes/$notesIds': typeof NotesNotesIdsRoute;
  '/payment/$token': typeof PaymentTokenRoute;
  '/payroll/manage-perdiem': typeof PayrollManagePerdiemRoute;
  '/permitAdmin/$permitGroupId': typeof PermitAdminPermitGroupIdRouteWithChildren;
  '/project/$projectId': typeof ProjectProjectIdRoute;
  '/projectResources/$projectId': typeof ProjectResourcesProjectIdRoute;
  '/projects/estimates': typeof ProjectsEstimatesRoute;
  '/properties/$propertyId': typeof PropertiesPropertyIdRoute;
  '/property-details/$propertyId': typeof PropertyDetailsPropertyIdRoute;
  '/proposal-job-details-customer-preview/$quoteDocumentId': typeof ProposalJobDetailsCustomerPreviewQuoteDocumentIdRoute;
  '/proposal-job-details-customer/$token': typeof ProposalJobDetailsCustomerTokenRoute;
  '/reimbursements/$reimbursementOwnerId': typeof ReimbursementsReimbursementOwnerIdRoute;
  '/reports/comm-diff': typeof ReportsCommDiffRoute;
  '/reports/employee-org-chart': typeof ReportsEmployeeOrgChartRoute;
  '/reports/system-install-anniversary': typeof ReportsSystemInstallAnniversaryRoute;
  '/reports/time-off': typeof ReportsTimeOffRoute;
  '/reports/timeoff-audit': typeof ReportsTimeoffAuditRoute;
  '/softphone/new-job': typeof SoftphoneNewJobRoute;
  '/softphone/oauth-callback': typeof SoftphoneOauthCallbackRoute;
  '/softphone/popup': typeof SoftphonePopupRoute;
  '/spiffLog/$spiffLogOwnerId': typeof SpiffLogSpiffLogOwnerIdRoute;
  '/spiffLog/allocator': typeof SpiffLogAllocatorRoute;
  '/test-payment-link/$invoiceId': typeof TestPaymentLinkInvoiceIdRoute;
  '/timeoff/$timeOffRequestId': typeof TimeoffTimeOffRequestIdRoute;
  '/timesheet/$timesheetOwnerId': typeof TimesheetTimesheetOwnerIdRoute;
  '/toolFundCatalog/$catalogItemId': typeof ToolFundCatalogCatalogItemIdRoute;
  '/toolLog/$toolLogOwnerId': typeof ToolLogToolLogOwnerIdRoute;
  '/tools/nitrogen': typeof ToolsNitrogenRoute;
  '/travel-estimate/$jobNumber': typeof TravelEstimateJobNumberRoute;
  '/calendar/': typeof CalendarIndexRoute;
  '/customers/': typeof CustomersIndexRoute;
  '/employees/': typeof EmployeesIndexRoute;
  '/hrDashboard/': typeof HrDashboardIndexRoute;
  '/jobs/': typeof JobsIndexRoute;
  '/memberships/': typeof MembershipsIndexRoute;
  '/notes/': typeof NotesIndexRoute;
  '/payroll/': typeof PayrollIndexRoute;
  '/properties/': typeof PropertiesIndexRoute;
  '/reports/': typeof ReportsIndexRoute;
  '/spiffLog/': typeof SpiffLogIndexRoute;
  '/toolFundCatalog/': typeof ToolFundCatalogIndexRoute;
  '/toolLog/': typeof ToolLogIndexRoute;
  '/departments/edit/$functionId': typeof DepartmentsEditFunctionIdRoute;
  '/documents/invoices/$invoiceId': typeof DocumentsInvoicesInvoiceIdRoute;
  '/employees/items/options': typeof EmployeesItemsOptionsRoute;
  '/hrDashboard/newFire/create': typeof HrDashboardNewFireCreateRoute;
  '/hrDashboard/newHire/create': typeof HrDashboardNewHireCreateRoute;
  '/stripe/success/$token': typeof StripeSuccessTokenRoute;
  '/user/time-off/$userId': typeof UserTimeOffUserIdRoute;
  '/customers/$userId/properties/$propertyId': typeof CustomersUserIdPropertiesPropertyIdRoute;
  '/hrDashboard/newFire/edit/$userId': typeof HrDashboardNewFireEditUserIdRoute;
  '/hrDashboard/newHire/edit/$newHireId': typeof HrDashboardNewHireEditNewHireIdRoute;
  '/permitAdmin/$permitGroupId/permits/$permitId': typeof PermitAdminPermitGroupIdPermitsPermitIdRoute;
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | '/'
    | '/accounts'
    | '/accountsPayable'
    | '/analytics'
    | '/appointment-scheduler'
    | '/businesses'
    | '/callWindow'
    | '/callsPending'
    | '/commercial-service-queue'
    | '/creditCards'
    | '/customer-service-dashboard'
    | '/dashboard-home'
    | '/departments'
    | '/dispatch'
    | '/dispatch-map'
    | '/dispatch-new'
    | '/documents'
    | '/driverDashboard'
    | '/first-calls'
    | '/firstcalls'
    | '/formsDashboard'
    | '/helpDesk'
    | '/home'
    | '/inventory-requests'
    | '/jobs-unified'
    | '/lodgingAdmin'
    | '/lodgingRequests'
    | '/logout'
    | '/membership-report'
    | '/my-account'
    | '/newHire'
    | '/perdiem'
    | '/permissionsManager'
    | '/permitAdmin'
    | '/project-schedule'
    | '/projectResources'
    | '/proposals'
    | '/quickbooks-customer-mapping'
    | '/quickbooks-oauth'
    | '/reports'
    | '/requisition-catalog'
    | '/search'
    | '/servicechannel-oauth'
    | '/toolFundDashboard'
    | '/toolFundRequests'
    | '/tools'
    | '/transactionAdmin'
    | '/transactions'
    | '/vehicles'
    | '/accept-proposal/$token'
    | '/admin/email-tasks'
    | '/admin/feature-flags'
    | '/admin/memberships-catalog'
    | '/admin/servicechannel-mappings'
    | '/calendar/$initialCustomerId'
    | '/card/$token'
    | '/cost-report/$jobNumber'
    | '/customer-details/$customerId'
    | '/customer-proposal-preview/$quoteDocumentId'
    | '/customer-proposal/$token'
    | '/customers/$customerId'
    | '/customers/add'
    | '/decline-proposal/$token'
    | '/departments/add'
    | '/document/$link'
    | '/hrDashboard/$prId'
    | '/job-details/$eventId'
    | '/jobs-admin/$jobId'
    | '/jobs/$jobId'
    | '/lodgingAdmin/$lodgingRequestId'
    | '/lodgingAssignment/$lodgingAssignmentId'
    | '/memoPreview/$memoId'
    | '/notes/$notesIds'
    | '/payment/$token'
    | '/payroll/manage-perdiem'
    | '/permitAdmin/$permitGroupId'
    | '/project/$projectId'
    | '/projectResources/$projectId'
    | '/projects/estimates'
    | '/properties/$propertyId'
    | '/property-details/$propertyId'
    | '/proposal-job-details-customer-preview/$quoteDocumentId'
    | '/proposal-job-details-customer/$token'
    | '/reimbursements/$reimbursementOwnerId'
    | '/reports/comm-diff'
    | '/reports/employee-org-chart'
    | '/reports/system-install-anniversary'
    | '/reports/time-off'
    | '/reports/timeoff-audit'
    | '/softphone/new-job'
    | '/softphone/oauth-callback'
    | '/softphone/popup'
    | '/spiffLog/$spiffLogOwnerId'
    | '/spiffLog/allocator'
    | '/test-payment-link/$invoiceId'
    | '/timeoff/$timeOffRequestId'
    | '/timesheet/$timesheetOwnerId'
    | '/toolFundCatalog/$catalogItemId'
    | '/toolLog/$toolLogOwnerId'
    | '/tools/nitrogen'
    | '/travel-estimate/$jobNumber'
    | '/calendar'
    | '/customers'
    | '/employees'
    | '/hrDashboard'
    | '/jobs'
    | '/memberships'
    | '/notes'
    | '/payroll'
    | '/properties'
    | '/reports/'
    | '/spiffLog'
    | '/toolFundCatalog'
    | '/toolLog'
    | '/departments/edit/$functionId'
    | '/documents/invoices/$invoiceId'
    | '/employees/items/options'
    | '/hrDashboard/newFire/create'
    | '/hrDashboard/newHire/create'
    | '/stripe/success/$token'
    | '/user/time-off/$userId'
    | '/customers/$userId/properties/$propertyId'
    | '/hrDashboard/newFire/edit/$userId'
    | '/hrDashboard/newHire/edit/$newHireId'
    | '/permitAdmin/$permitGroupId/permits/$permitId';
  fileRoutesByTo: FileRoutesByTo;
  to:
    | '/'
    | '/accounts'
    | '/accountsPayable'
    | '/analytics'
    | '/appointment-scheduler'
    | '/businesses'
    | '/callWindow'
    | '/callsPending'
    | '/commercial-service-queue'
    | '/creditCards'
    | '/customer-service-dashboard'
    | '/dashboard-home'
    | '/departments'
    | '/dispatch'
    | '/dispatch-map'
    | '/dispatch-new'
    | '/documents'
    | '/driverDashboard'
    | '/first-calls'
    | '/firstcalls'
    | '/formsDashboard'
    | '/helpDesk'
    | '/home'
    | '/inventory-requests'
    | '/jobs-unified'
    | '/lodgingAdmin'
    | '/lodgingRequests'
    | '/logout'
    | '/membership-report'
    | '/my-account'
    | '/newHire'
    | '/perdiem'
    | '/permissionsManager'
    | '/permitAdmin'
    | '/project-schedule'
    | '/projectResources'
    | '/proposals'
    | '/quickbooks-customer-mapping'
    | '/quickbooks-oauth'
    | '/requisition-catalog'
    | '/search'
    | '/servicechannel-oauth'
    | '/toolFundDashboard'
    | '/toolFundRequests'
    | '/tools'
    | '/transactionAdmin'
    | '/transactions'
    | '/vehicles'
    | '/accept-proposal/$token'
    | '/admin/email-tasks'
    | '/admin/feature-flags'
    | '/admin/memberships-catalog'
    | '/admin/servicechannel-mappings'
    | '/calendar/$initialCustomerId'
    | '/card/$token'
    | '/cost-report/$jobNumber'
    | '/customer-details/$customerId'
    | '/customer-proposal-preview/$quoteDocumentId'
    | '/customer-proposal/$token'
    | '/customers/$customerId'
    | '/customers/add'
    | '/decline-proposal/$token'
    | '/departments/add'
    | '/document/$link'
    | '/hrDashboard/$prId'
    | '/job-details/$eventId'
    | '/jobs-admin/$jobId'
    | '/jobs/$jobId'
    | '/lodgingAdmin/$lodgingRequestId'
    | '/lodgingAssignment/$lodgingAssignmentId'
    | '/memoPreview/$memoId'
    | '/notes/$notesIds'
    | '/payment/$token'
    | '/payroll/manage-perdiem'
    | '/permitAdmin/$permitGroupId'
    | '/project/$projectId'
    | '/projectResources/$projectId'
    | '/projects/estimates'
    | '/properties/$propertyId'
    | '/property-details/$propertyId'
    | '/proposal-job-details-customer-preview/$quoteDocumentId'
    | '/proposal-job-details-customer/$token'
    | '/reimbursements/$reimbursementOwnerId'
    | '/reports/comm-diff'
    | '/reports/employee-org-chart'
    | '/reports/system-install-anniversary'
    | '/reports/time-off'
    | '/reports/timeoff-audit'
    | '/softphone/new-job'
    | '/softphone/oauth-callback'
    | '/softphone/popup'
    | '/spiffLog/$spiffLogOwnerId'
    | '/spiffLog/allocator'
    | '/test-payment-link/$invoiceId'
    | '/timeoff/$timeOffRequestId'
    | '/timesheet/$timesheetOwnerId'
    | '/toolFundCatalog/$catalogItemId'
    | '/toolLog/$toolLogOwnerId'
    | '/tools/nitrogen'
    | '/travel-estimate/$jobNumber'
    | '/calendar'
    | '/customers'
    | '/employees'
    | '/hrDashboard'
    | '/jobs'
    | '/memberships'
    | '/notes'
    | '/payroll'
    | '/properties'
    | '/reports'
    | '/spiffLog'
    | '/toolFundCatalog'
    | '/toolLog'
    | '/departments/edit/$functionId'
    | '/documents/invoices/$invoiceId'
    | '/employees/items/options'
    | '/hrDashboard/newFire/create'
    | '/hrDashboard/newHire/create'
    | '/stripe/success/$token'
    | '/user/time-off/$userId'
    | '/customers/$userId/properties/$propertyId'
    | '/hrDashboard/newFire/edit/$userId'
    | '/hrDashboard/newHire/edit/$newHireId'
    | '/permitAdmin/$permitGroupId/permits/$permitId';
  id:
    | '__root__'
    | '/'
    | '/accounts'
    | '/accountsPayable'
    | '/analytics'
    | '/appointment-scheduler'
    | '/businesses'
    | '/callWindow'
    | '/callsPending'
    | '/commercial-service-queue'
    | '/creditCards'
    | '/customer-service-dashboard'
    | '/dashboard-home'
    | '/departments'
    | '/dispatch'
    | '/dispatch-map'
    | '/dispatch-new'
    | '/documents'
    | '/driverDashboard'
    | '/first-calls'
    | '/firstcalls'
    | '/formsDashboard'
    | '/helpDesk'
    | '/home'
    | '/inventory-requests'
    | '/jobs-unified'
    | '/lodgingAdmin'
    | '/lodgingRequests'
    | '/logout'
    | '/membership-report'
    | '/my-account'
    | '/newHire'
    | '/perdiem'
    | '/permissionsManager'
    | '/permitAdmin'
    | '/project-schedule'
    | '/projectResources'
    | '/proposals'
    | '/quickbooks-customer-mapping'
    | '/quickbooks-oauth'
    | '/reports'
    | '/requisition-catalog'
    | '/search'
    | '/servicechannel-oauth'
    | '/toolFundDashboard'
    | '/toolFundRequests'
    | '/tools'
    | '/transactionAdmin'
    | '/transactions'
    | '/vehicles'
    | '/accept-proposal/$token'
    | '/admin/email-tasks'
    | '/admin/feature-flags'
    | '/admin/memberships-catalog'
    | '/admin/servicechannel-mappings'
    | '/calendar/$initialCustomerId'
    | '/card/$token'
    | '/cost-report/$jobNumber'
    | '/customer-details/$customerId'
    | '/customer-proposal-preview/$quoteDocumentId'
    | '/customer-proposal/$token'
    | '/customers/$customerId'
    | '/customers/add'
    | '/decline-proposal/$token'
    | '/departments/add'
    | '/document/$link'
    | '/hrDashboard/$prId'
    | '/job-details/$eventId'
    | '/jobs-admin/$jobId'
    | '/jobs/$jobId'
    | '/lodgingAdmin/$lodgingRequestId'
    | '/lodgingAssignment/$lodgingAssignmentId'
    | '/memoPreview/$memoId'
    | '/notes/$notesIds'
    | '/payment/$token'
    | '/payroll/manage-perdiem'
    | '/permitAdmin/$permitGroupId'
    | '/project/$projectId'
    | '/projectResources/$projectId'
    | '/projects/estimates'
    | '/properties/$propertyId'
    | '/property-details/$propertyId'
    | '/proposal-job-details-customer-preview/$quoteDocumentId'
    | '/proposal-job-details-customer/$token'
    | '/reimbursements/$reimbursementOwnerId'
    | '/reports/comm-diff'
    | '/reports/employee-org-chart'
    | '/reports/system-install-anniversary'
    | '/reports/time-off'
    | '/reports/timeoff-audit'
    | '/softphone/new-job'
    | '/softphone/oauth-callback'
    | '/softphone/popup'
    | '/spiffLog/$spiffLogOwnerId'
    | '/spiffLog/allocator'
    | '/test-payment-link/$invoiceId'
    | '/timeoff/$timeOffRequestId'
    | '/timesheet/$timesheetOwnerId'
    | '/toolFundCatalog/$catalogItemId'
    | '/toolLog/$toolLogOwnerId'
    | '/tools/nitrogen'
    | '/travel-estimate/$jobNumber'
    | '/calendar/'
    | '/customers/'
    | '/employees/'
    | '/hrDashboard/'
    | '/jobs/'
    | '/memberships/'
    | '/notes/'
    | '/payroll/'
    | '/properties/'
    | '/reports/'
    | '/spiffLog/'
    | '/toolFundCatalog/'
    | '/toolLog/'
    | '/departments/edit/$functionId'
    | '/documents/invoices/$invoiceId'
    | '/employees/items/options'
    | '/hrDashboard/newFire/create'
    | '/hrDashboard/newHire/create'
    | '/stripe/success/$token'
    | '/user/time-off/$userId'
    | '/customers/$userId/properties/$propertyId'
    | '/hrDashboard/newFire/edit/$userId'
    | '/hrDashboard/newHire/edit/$newHireId'
    | '/permitAdmin/$permitGroupId/permits/$permitId';
  fileRoutesById: FileRoutesById;
}

export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AccountsRoute: typeof AccountsRoute;
  AccountsPayableRoute: typeof AccountsPayableRoute;
  AnalyticsRoute: typeof AnalyticsRoute;
  AppointmentSchedulerRoute: typeof AppointmentSchedulerRoute;
  BusinessesRoute: typeof BusinessesRoute;
  CallWindowRoute: typeof CallWindowRoute;
  CallsPendingRoute: typeof CallsPendingRoute;
  CommercialServiceQueueRoute: typeof CommercialServiceQueueRoute;
  CreditCardsRoute: typeof CreditCardsRoute;
  CustomerServiceDashboardRoute: typeof CustomerServiceDashboardRoute;
  DashboardHomeRoute: typeof DashboardHomeRoute;
  DepartmentsRoute: typeof DepartmentsRouteWithChildren;
  DispatchRoute: typeof DispatchRoute;
  DispatchMapRoute: typeof DispatchMapRoute;
  DispatchNewRoute: typeof DispatchNewRoute;
  DocumentsRoute: typeof DocumentsRouteWithChildren;
  DriverDashboardRoute: typeof DriverDashboardRoute;
  FirstCallsRoute: typeof FirstCallsRoute;
  FirstcallsRoute: typeof FirstcallsRoute;
  FormsDashboardRoute: typeof FormsDashboardRoute;
  HelpDeskRoute: typeof HelpDeskRoute;
  HomeRoute: typeof HomeRoute;
  InventoryRequestsRoute: typeof InventoryRequestsRoute;
  JobsUnifiedRoute: typeof JobsUnifiedRoute;
  LodgingAdminRoute: typeof LodgingAdminRouteWithChildren;
  LodgingRequestsRoute: typeof LodgingRequestsRoute;
  LogoutRoute: typeof LogoutRoute;
  MembershipReportRoute: typeof MembershipReportRoute;
  MyAccountRoute: typeof MyAccountRoute;
  NewHireRoute: typeof NewHireRoute;
  PerdiemRoute: typeof PerdiemRoute;
  PermissionsManagerRoute: typeof PermissionsManagerRoute;
  PermitAdminRoute: typeof PermitAdminRouteWithChildren;
  ProjectScheduleRoute: typeof ProjectScheduleRoute;
  ProjectResourcesRoute: typeof ProjectResourcesRouteWithChildren;
  ProposalsRoute: typeof ProposalsRoute;
  QuickbooksCustomerMappingRoute: typeof QuickbooksCustomerMappingRoute;
  QuickbooksOauthRoute: typeof QuickbooksOauthRoute;
  ReportsRoute: typeof ReportsRouteWithChildren;
  RequisitionCatalogRoute: typeof RequisitionCatalogRoute;
  SearchRoute: typeof SearchRoute;
  ServicechannelOauthRoute: typeof ServicechannelOauthRoute;
  ToolFundDashboardRoute: typeof ToolFundDashboardRoute;
  ToolFundRequestsRoute: typeof ToolFundRequestsRoute;
  ToolsRoute: typeof ToolsRouteWithChildren;
  TransactionAdminRoute: typeof TransactionAdminRoute;
  TransactionsRoute: typeof TransactionsRoute;
  VehiclesRoute: typeof VehiclesRoute;
  AcceptProposalTokenRoute: typeof AcceptProposalTokenRoute;
  AdminEmailTasksRoute: typeof AdminEmailTasksRoute;
  AdminFeatureFlagsRoute: typeof AdminFeatureFlagsRoute;
  AdminMembershipsCatalogRoute: typeof AdminMembershipsCatalogRoute;
  AdminServicechannelMappingsRoute: typeof AdminServicechannelMappingsRoute;
  CalendarInitialCustomerIdRoute: typeof CalendarInitialCustomerIdRoute;
  CardTokenRoute: typeof CardTokenRoute;
  CostReportJobNumberRoute: typeof CostReportJobNumberRoute;
  CustomerDetailsCustomerIdRoute: typeof CustomerDetailsCustomerIdRoute;
  CustomerProposalPreviewQuoteDocumentIdRoute: typeof CustomerProposalPreviewQuoteDocumentIdRoute;
  CustomerProposalTokenRoute: typeof CustomerProposalTokenRoute;
  CustomersCustomerIdRoute: typeof CustomersCustomerIdRoute;
  CustomersAddRoute: typeof CustomersAddRoute;
  DeclineProposalTokenRoute: typeof DeclineProposalTokenRoute;
  DocumentLinkRoute: typeof DocumentLinkRoute;
  HrDashboardPrIdRoute: typeof HrDashboardPrIdRoute;
  JobDetailsEventIdRoute: typeof JobDetailsEventIdRoute;
  JobsAdminJobIdRoute: typeof JobsAdminJobIdRoute;
  JobsJobIdRoute: typeof JobsJobIdRoute;
  LodgingAssignmentLodgingAssignmentIdRoute: typeof LodgingAssignmentLodgingAssignmentIdRoute;
  MemoPreviewMemoIdRoute: typeof MemoPreviewMemoIdRoute;
  NotesNotesIdsRoute: typeof NotesNotesIdsRoute;
  PaymentTokenRoute: typeof PaymentTokenRoute;
  PayrollManagePerdiemRoute: typeof PayrollManagePerdiemRoute;
  ProjectProjectIdRoute: typeof ProjectProjectIdRoute;
  ProjectsEstimatesRoute: typeof ProjectsEstimatesRoute;
  PropertiesPropertyIdRoute: typeof PropertiesPropertyIdRoute;
  PropertyDetailsPropertyIdRoute: typeof PropertyDetailsPropertyIdRoute;
  ProposalJobDetailsCustomerPreviewQuoteDocumentIdRoute: typeof ProposalJobDetailsCustomerPreviewQuoteDocumentIdRoute;
  ProposalJobDetailsCustomerTokenRoute: typeof ProposalJobDetailsCustomerTokenRoute;
  ReimbursementsReimbursementOwnerIdRoute: typeof ReimbursementsReimbursementOwnerIdRoute;
  SoftphoneNewJobRoute: typeof SoftphoneNewJobRoute;
  SoftphoneOauthCallbackRoute: typeof SoftphoneOauthCallbackRoute;
  SoftphonePopupRoute: typeof SoftphonePopupRoute;
  SpiffLogSpiffLogOwnerIdRoute: typeof SpiffLogSpiffLogOwnerIdRoute;
  SpiffLogAllocatorRoute: typeof SpiffLogAllocatorRoute;
  TestPaymentLinkInvoiceIdRoute: typeof TestPaymentLinkInvoiceIdRoute;
  TimeoffTimeOffRequestIdRoute: typeof TimeoffTimeOffRequestIdRoute;
  TimesheetTimesheetOwnerIdRoute: typeof TimesheetTimesheetOwnerIdRoute;
  ToolFundCatalogCatalogItemIdRoute: typeof ToolFundCatalogCatalogItemIdRoute;
  ToolLogToolLogOwnerIdRoute: typeof ToolLogToolLogOwnerIdRoute;
  TravelEstimateJobNumberRoute: typeof TravelEstimateJobNumberRoute;
  CalendarIndexRoute: typeof CalendarIndexRoute;
  CustomersIndexRoute: typeof CustomersIndexRoute;
  EmployeesIndexRoute: typeof EmployeesIndexRoute;
  HrDashboardIndexRoute: typeof HrDashboardIndexRoute;
  JobsIndexRoute: typeof JobsIndexRoute;
  MembershipsIndexRoute: typeof MembershipsIndexRoute;
  NotesIndexRoute: typeof NotesIndexRoute;
  PayrollIndexRoute: typeof PayrollIndexRoute;
  PropertiesIndexRoute: typeof PropertiesIndexRoute;
  SpiffLogIndexRoute: typeof SpiffLogIndexRoute;
  ToolFundCatalogIndexRoute: typeof ToolFundCatalogIndexRoute;
  ToolLogIndexRoute: typeof ToolLogIndexRoute;
  EmployeesItemsOptionsRoute: typeof EmployeesItemsOptionsRoute;
  HrDashboardNewFireCreateRoute: typeof HrDashboardNewFireCreateRoute;
  HrDashboardNewHireCreateRoute: typeof HrDashboardNewHireCreateRoute;
  StripeSuccessTokenRoute: typeof StripeSuccessTokenRoute;
  UserTimeOffUserIdRoute: typeof UserTimeOffUserIdRoute;
  CustomersUserIdPropertiesPropertyIdRoute: typeof CustomersUserIdPropertiesPropertyIdRoute;
  HrDashboardNewFireEditUserIdRoute: typeof HrDashboardNewFireEditUserIdRoute;
  HrDashboardNewHireEditNewHireIdRoute: typeof HrDashboardNewHireEditNewHireIdRoute;
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AccountsRoute: AccountsRoute,
  AccountsPayableRoute: AccountsPayableRoute,
  AnalyticsRoute: AnalyticsRoute,
  AppointmentSchedulerRoute: AppointmentSchedulerRoute,
  BusinessesRoute: BusinessesRoute,
  CallWindowRoute: CallWindowRoute,
  CallsPendingRoute: CallsPendingRoute,
  CommercialServiceQueueRoute: CommercialServiceQueueRoute,
  CreditCardsRoute: CreditCardsRoute,
  CustomerServiceDashboardRoute: CustomerServiceDashboardRoute,
  DashboardHomeRoute: DashboardHomeRoute,
  DepartmentsRoute: DepartmentsRouteWithChildren,
  DispatchRoute: DispatchRoute,
  DispatchMapRoute: DispatchMapRoute,
  DispatchNewRoute: DispatchNewRoute,
  DocumentsRoute: DocumentsRouteWithChildren,
  DriverDashboardRoute: DriverDashboardRoute,
  FirstCallsRoute: FirstCallsRoute,
  FirstcallsRoute: FirstcallsRoute,
  FormsDashboardRoute: FormsDashboardRoute,
  HelpDeskRoute: HelpDeskRoute,
  HomeRoute: HomeRoute,
  InventoryRequestsRoute: InventoryRequestsRoute,
  JobsUnifiedRoute: JobsUnifiedRoute,
  LodgingAdminRoute: LodgingAdminRouteWithChildren,
  LodgingRequestsRoute: LodgingRequestsRoute,
  LogoutRoute: LogoutRoute,
  MembershipReportRoute: MembershipReportRoute,
  MyAccountRoute: MyAccountRoute,
  NewHireRoute: NewHireRoute,
  PerdiemRoute: PerdiemRoute,
  PermissionsManagerRoute: PermissionsManagerRoute,
  PermitAdminRoute: PermitAdminRouteWithChildren,
  ProjectScheduleRoute: ProjectScheduleRoute,
  ProjectResourcesRoute: ProjectResourcesRouteWithChildren,
  ProposalsRoute: ProposalsRoute,
  QuickbooksCustomerMappingRoute: QuickbooksCustomerMappingRoute,
  QuickbooksOauthRoute: QuickbooksOauthRoute,
  ReportsRoute: ReportsRouteWithChildren,
  RequisitionCatalogRoute: RequisitionCatalogRoute,
  SearchRoute: SearchRoute,
  ServicechannelOauthRoute: ServicechannelOauthRoute,
  ToolFundDashboardRoute: ToolFundDashboardRoute,
  ToolFundRequestsRoute: ToolFundRequestsRoute,
  ToolsRoute: ToolsRouteWithChildren,
  TransactionAdminRoute: TransactionAdminRoute,
  TransactionsRoute: TransactionsRoute,
  VehiclesRoute: VehiclesRoute,
  AcceptProposalTokenRoute: AcceptProposalTokenRoute,
  AdminEmailTasksRoute: AdminEmailTasksRoute,
  AdminFeatureFlagsRoute: AdminFeatureFlagsRoute,
  AdminMembershipsCatalogRoute: AdminMembershipsCatalogRoute,
  AdminServicechannelMappingsRoute: AdminServicechannelMappingsRoute,
  CalendarInitialCustomerIdRoute: CalendarInitialCustomerIdRoute,
  CardTokenRoute: CardTokenRoute,
  CostReportJobNumberRoute: CostReportJobNumberRoute,
  CustomerDetailsCustomerIdRoute: CustomerDetailsCustomerIdRoute,
  CustomerProposalPreviewQuoteDocumentIdRoute: CustomerProposalPreviewQuoteDocumentIdRoute,
  CustomerProposalTokenRoute: CustomerProposalTokenRoute,
  CustomersCustomerIdRoute: CustomersCustomerIdRoute,
  CustomersAddRoute: CustomersAddRoute,
  DeclineProposalTokenRoute: DeclineProposalTokenRoute,
  DocumentLinkRoute: DocumentLinkRoute,
  HrDashboardPrIdRoute: HrDashboardPrIdRoute,
  JobDetailsEventIdRoute: JobDetailsEventIdRoute,
  JobsAdminJobIdRoute: JobsAdminJobIdRoute,
  JobsJobIdRoute: JobsJobIdRoute,
  LodgingAssignmentLodgingAssignmentIdRoute: LodgingAssignmentLodgingAssignmentIdRoute,
  MemoPreviewMemoIdRoute: MemoPreviewMemoIdRoute,
  NotesNotesIdsRoute: NotesNotesIdsRoute,
  PaymentTokenRoute: PaymentTokenRoute,
  PayrollManagePerdiemRoute: PayrollManagePerdiemRoute,
  ProjectProjectIdRoute: ProjectProjectIdRoute,
  ProjectsEstimatesRoute: ProjectsEstimatesRoute,
  PropertiesPropertyIdRoute: PropertiesPropertyIdRoute,
  PropertyDetailsPropertyIdRoute: PropertyDetailsPropertyIdRoute,
  ProposalJobDetailsCustomerPreviewQuoteDocumentIdRoute:
    ProposalJobDetailsCustomerPreviewQuoteDocumentIdRoute,
  ProposalJobDetailsCustomerTokenRoute: ProposalJobDetailsCustomerTokenRoute,
  ReimbursementsReimbursementOwnerIdRoute: ReimbursementsReimbursementOwnerIdRoute,
  SoftphoneNewJobRoute: SoftphoneNewJobRoute,
  SoftphoneOauthCallbackRoute: SoftphoneOauthCallbackRoute,
  SoftphonePopupRoute: SoftphonePopupRoute,
  SpiffLogSpiffLogOwnerIdRoute: SpiffLogSpiffLogOwnerIdRoute,
  SpiffLogAllocatorRoute: SpiffLogAllocatorRoute,
  TestPaymentLinkInvoiceIdRoute: TestPaymentLinkInvoiceIdRoute,
  TimeoffTimeOffRequestIdRoute: TimeoffTimeOffRequestIdRoute,
  TimesheetTimesheetOwnerIdRoute: TimesheetTimesheetOwnerIdRoute,
  ToolFundCatalogCatalogItemIdRoute: ToolFundCatalogCatalogItemIdRoute,
  ToolLogToolLogOwnerIdRoute: ToolLogToolLogOwnerIdRoute,
  TravelEstimateJobNumberRoute: TravelEstimateJobNumberRoute,
  CalendarIndexRoute: CalendarIndexRoute,
  CustomersIndexRoute: CustomersIndexRoute,
  EmployeesIndexRoute: EmployeesIndexRoute,
  HrDashboardIndexRoute: HrDashboardIndexRoute,
  JobsIndexRoute: JobsIndexRoute,
  MembershipsIndexRoute: MembershipsIndexRoute,
  NotesIndexRoute: NotesIndexRoute,
  PayrollIndexRoute: PayrollIndexRoute,
  PropertiesIndexRoute: PropertiesIndexRoute,
  SpiffLogIndexRoute: SpiffLogIndexRoute,
  ToolFundCatalogIndexRoute: ToolFundCatalogIndexRoute,
  ToolLogIndexRoute: ToolLogIndexRoute,
  EmployeesItemsOptionsRoute: EmployeesItemsOptionsRoute,
  HrDashboardNewFireCreateRoute: HrDashboardNewFireCreateRoute,
  HrDashboardNewHireCreateRoute: HrDashboardNewHireCreateRoute,
  StripeSuccessTokenRoute: StripeSuccessTokenRoute,
  UserTimeOffUserIdRoute: UserTimeOffUserIdRoute,
  CustomersUserIdPropertiesPropertyIdRoute: CustomersUserIdPropertiesPropertyIdRoute,
  HrDashboardNewFireEditUserIdRoute: HrDashboardNewFireEditUserIdRoute,
  HrDashboardNewHireEditNewHireIdRoute: HrDashboardNewHireEditNewHireIdRoute,
};

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/",
        "/accounts",
        "/accountsPayable",
        "/analytics",
        "/appointment-scheduler",
        "/businesses",
        "/callWindow",
        "/callsPending",
        "/commercial-service-queue",
        "/creditCards",
        "/customer-service-dashboard",
        "/dashboard-home",
        "/departments",
        "/dispatch",
        "/dispatch-map",
        "/dispatch-new",
        "/documents",
        "/driverDashboard",
        "/first-calls",
        "/firstcalls",
        "/formsDashboard",
        "/helpDesk",
        "/home",
        "/inventory-requests",
        "/jobs-unified",
        "/lodgingAdmin",
        "/lodgingRequests",
        "/logout",
        "/membership-report",
        "/my-account",
        "/newHire",
        "/perdiem",
        "/permissionsManager",
        "/permitAdmin",
        "/project-schedule",
        "/projectResources",
        "/proposals",
        "/quickbooks-customer-mapping",
        "/quickbooks-oauth",
        "/reports",
        "/requisition-catalog",
        "/search",
        "/servicechannel-oauth",
        "/toolFundDashboard",
        "/toolFundRequests",
        "/tools",
        "/transactionAdmin",
        "/transactions",
        "/vehicles",
        "/accept-proposal/$token",
        "/admin/email-tasks",
        "/admin/feature-flags",
        "/admin/memberships-catalog",
        "/admin/servicechannel-mappings",
        "/calendar/$initialCustomerId",
        "/card/$token",
        "/cost-report/$jobNumber",
        "/customer-details/$customerId",
        "/customer-proposal-preview/$quoteDocumentId",
        "/customer-proposal/$token",
        "/customers/$customerId",
        "/customers/add",
        "/decline-proposal/$token",
        "/document/$link",
        "/hrDashboard/$prId",
        "/job-details/$eventId",
        "/jobs-admin/$jobId",
        "/jobs/$jobId",
        "/lodgingAssignment/$lodgingAssignmentId",
        "/memoPreview/$memoId",
        "/notes/$notesIds",
        "/payment/$token",
        "/payroll/manage-perdiem",
        "/project/$projectId",
        "/projects/estimates",
        "/properties/$propertyId",
        "/property-details/$propertyId",
        "/proposal-job-details-customer-preview/$quoteDocumentId",
        "/proposal-job-details-customer/$token",
        "/reimbursements/$reimbursementOwnerId",
        "/softphone/new-job",
        "/softphone/oauth-callback",
        "/softphone/popup",
        "/spiffLog/$spiffLogOwnerId",
        "/spiffLog/allocator",
        "/test-payment-link/$invoiceId",
        "/timeoff/$timeOffRequestId",
        "/timesheet/$timesheetOwnerId",
        "/toolFundCatalog/$catalogItemId",
        "/toolLog/$toolLogOwnerId",
        "/travel-estimate/$jobNumber",
        "/calendar/",
        "/customers/",
        "/employees/",
        "/hrDashboard/",
        "/jobs/",
        "/memberships/",
        "/notes/",
        "/payroll/",
        "/properties/",
        "/spiffLog/",
        "/toolFundCatalog/",
        "/toolLog/",
        "/employees/items/options",
        "/hrDashboard/newFire/create",
        "/hrDashboard/newHire/create",
        "/stripe/success/$token",
        "/user/time-off/$userId",
        "/customers/$userId/properties/$propertyId",
        "/hrDashboard/newFire/edit/$userId",
        "/hrDashboard/newHire/edit/$newHireId"
      ]
    },
    "/": {
      "filePath": "index.tsx"
    },
    "/accounts": {
      "filePath": "accounts.tsx"
    },
    "/accountsPayable": {
      "filePath": "accountsPayable.tsx"
    },
    "/analytics": {
      "filePath": "analytics.tsx"
    },
    "/appointment-scheduler": {
      "filePath": "appointment-scheduler.tsx"
    },
    "/businesses": {
      "filePath": "businesses.tsx"
    },
    "/callWindow": {
      "filePath": "callWindow.tsx"
    },
    "/callsPending": {
      "filePath": "callsPending.tsx"
    },
    "/commercial-service-queue": {
      "filePath": "commercial-service-queue.tsx"
    },
    "/creditCards": {
      "filePath": "creditCards.tsx"
    },
    "/customer-service-dashboard": {
      "filePath": "customer-service-dashboard.tsx"
    },
    "/dashboard-home": {
      "filePath": "dashboard-home.tsx"
    },
    "/departments": {
      "filePath": "departments.tsx",
      "children": [
        "/departments/add",
        "/departments/edit/$functionId"
      ]
    },
    "/dispatch": {
      "filePath": "dispatch.tsx"
    },
    "/dispatch-map": {
      "filePath": "dispatch-map.tsx"
    },
    "/dispatch-new": {
      "filePath": "dispatch-new.tsx"
    },
    "/documents": {
      "filePath": "documents.tsx",
      "children": [
        "/documents/invoices/$invoiceId"
      ]
    },
    "/driverDashboard": {
      "filePath": "driverDashboard.tsx"
    },
    "/first-calls": {
      "filePath": "first-calls.tsx"
    },
    "/firstcalls": {
      "filePath": "firstcalls.tsx"
    },
    "/formsDashboard": {
      "filePath": "formsDashboard.tsx"
    },
    "/helpDesk": {
      "filePath": "helpDesk.tsx"
    },
    "/home": {
      "filePath": "home.tsx"
    },
    "/inventory-requests": {
      "filePath": "inventory-requests.tsx"
    },
    "/jobs-unified": {
      "filePath": "jobs-unified.tsx"
    },
    "/lodgingAdmin": {
      "filePath": "lodgingAdmin.tsx",
      "children": [
        "/lodgingAdmin/$lodgingRequestId"
      ]
    },
    "/lodgingRequests": {
      "filePath": "lodgingRequests.tsx"
    },
    "/logout": {
      "filePath": "logout.tsx"
    },
    "/membership-report": {
      "filePath": "membership-report.tsx"
    },
    "/my-account": {
      "filePath": "my-account.tsx"
    },
    "/newHire": {
      "filePath": "newHire.tsx"
    },
    "/perdiem": {
      "filePath": "perdiem.tsx"
    },
    "/permissionsManager": {
      "filePath": "permissionsManager.tsx"
    },
    "/permitAdmin": {
      "filePath": "permitAdmin.tsx",
      "children": [
        "/permitAdmin/$permitGroupId"
      ]
    },
    "/project-schedule": {
      "filePath": "project-schedule.tsx"
    },
    "/projectResources": {
      "filePath": "projectResources.tsx",
      "children": [
        "/projectResources/$projectId"
      ]
    },
    "/proposals": {
      "filePath": "proposals.tsx"
    },
    "/quickbooks-customer-mapping": {
      "filePath": "quickbooks-customer-mapping.tsx"
    },
    "/quickbooks-oauth": {
      "filePath": "quickbooks-oauth.tsx"
    },
    "/reports": {
      "filePath": "reports.tsx",
      "children": [
        "/reports/comm-diff",
        "/reports/employee-org-chart",
        "/reports/system-install-anniversary",
        "/reports/time-off",
        "/reports/timeoff-audit",
        "/reports/"
      ]
    },
    "/requisition-catalog": {
      "filePath": "requisition-catalog.tsx"
    },
    "/search": {
      "filePath": "search.tsx"
    },
    "/servicechannel-oauth": {
      "filePath": "servicechannel-oauth.tsx"
    },
    "/toolFundDashboard": {
      "filePath": "toolFundDashboard.tsx"
    },
    "/toolFundRequests": {
      "filePath": "toolFundRequests.tsx"
    },
    "/tools": {
      "filePath": "tools.tsx",
      "children": [
        "/tools/nitrogen"
      ]
    },
    "/transactionAdmin": {
      "filePath": "transactionAdmin.tsx"
    },
    "/transactions": {
      "filePath": "transactions.tsx"
    },
    "/vehicles": {
      "filePath": "vehicles.tsx"
    },
    "/accept-proposal/$token": {
      "filePath": "accept-proposal.$token.tsx"
    },
    "/admin/email-tasks": {
      "filePath": "admin.email-tasks.tsx"
    },
    "/admin/feature-flags": {
      "filePath": "admin.feature-flags.tsx"
    },
    "/admin/memberships-catalog": {
      "filePath": "admin.memberships-catalog.tsx"
    },
    "/admin/servicechannel-mappings": {
      "filePath": "admin.servicechannel-mappings.tsx"
    },
    "/calendar/$initialCustomerId": {
      "filePath": "calendar/$initialCustomerId.tsx"
    },
    "/card/$token": {
      "filePath": "card.$token.tsx"
    },
    "/cost-report/$jobNumber": {
      "filePath": "cost-report.$jobNumber.tsx"
    },
    "/customer-details/$customerId": {
      "filePath": "customer-details.$customerId.tsx"
    },
    "/customer-proposal-preview/$quoteDocumentId": {
      "filePath": "customer-proposal-preview.$quoteDocumentId.tsx"
    },
    "/customer-proposal/$token": {
      "filePath": "customer-proposal.$token.tsx"
    },
    "/customers/$customerId": {
      "filePath": "customers/$customerId.tsx"
    },
    "/customers/add": {
      "filePath": "customers/add.tsx"
    },
    "/decline-proposal/$token": {
      "filePath": "decline-proposal.$token.tsx"
    },
    "/departments/add": {
      "filePath": "departments.add.tsx",
      "parent": "/departments"
    },
    "/document/$link": {
      "filePath": "document.$link.tsx"
    },
    "/hrDashboard/$prId": {
      "filePath": "hrDashboard/$prId.tsx"
    },
    "/job-details/$eventId": {
      "filePath": "job-details.$eventId.tsx"
    },
    "/jobs-admin/$jobId": {
      "filePath": "jobs-admin.$jobId.tsx"
    },
    "/jobs/$jobId": {
      "filePath": "jobs/$jobId.tsx"
    },
    "/lodgingAdmin/$lodgingRequestId": {
      "filePath": "lodgingAdmin.$lodgingRequestId.tsx",
      "parent": "/lodgingAdmin"
    },
    "/lodgingAssignment/$lodgingAssignmentId": {
      "filePath": "lodgingAssignment.$lodgingAssignmentId.tsx"
    },
    "/memoPreview/$memoId": {
      "filePath": "memoPreview.$memoId.tsx"
    },
    "/notes/$notesIds": {
      "filePath": "notes/$notesIds.tsx"
    },
    "/payment/$token": {
      "filePath": "payment.$token.tsx"
    },
    "/payroll/manage-perdiem": {
      "filePath": "payroll/manage-perdiem.tsx"
    },
    "/permitAdmin/$permitGroupId": {
      "filePath": "permitAdmin.$permitGroupId.tsx",
      "parent": "/permitAdmin",
      "children": [
        "/permitAdmin/$permitGroupId/permits/$permitId"
      ]
    },
    "/project/$projectId": {
      "filePath": "project.$projectId.tsx"
    },
    "/projectResources/$projectId": {
      "filePath": "projectResources.$projectId.tsx",
      "parent": "/projectResources"
    },
    "/projects/estimates": {
      "filePath": "projects.estimates.tsx"
    },
    "/properties/$propertyId": {
      "filePath": "properties/$propertyId.tsx"
    },
    "/property-details/$propertyId": {
      "filePath": "property-details.$propertyId.tsx"
    },
    "/proposal-job-details-customer-preview/$quoteDocumentId": {
      "filePath": "proposal-job-details-customer-preview.$quoteDocumentId.tsx"
    },
    "/proposal-job-details-customer/$token": {
      "filePath": "proposal-job-details-customer.$token.tsx"
    },
    "/reimbursements/$reimbursementOwnerId": {
      "filePath": "reimbursements.$reimbursementOwnerId.tsx"
    },
    "/reports/comm-diff": {
      "filePath": "reports/comm-diff.tsx",
      "parent": "/reports"
    },
    "/reports/employee-org-chart": {
      "filePath": "reports.employee-org-chart.tsx",
      "parent": "/reports"
    },
    "/reports/system-install-anniversary": {
      "filePath": "reports/system-install-anniversary.tsx",
      "parent": "/reports"
    },
    "/reports/time-off": {
      "filePath": "reports/time-off.tsx",
      "parent": "/reports"
    },
    "/reports/timeoff-audit": {
      "filePath": "reports.timeoff-audit.tsx",
      "parent": "/reports"
    },
    "/softphone/new-job": {
      "filePath": "softphone/new-job.tsx"
    },
    "/softphone/oauth-callback": {
      "filePath": "softphone/oauth-callback.tsx"
    },
    "/softphone/popup": {
      "filePath": "softphone/popup.tsx"
    },
    "/spiffLog/$spiffLogOwnerId": {
      "filePath": "spiffLog/$spiffLogOwnerId.tsx"
    },
    "/spiffLog/allocator": {
      "filePath": "spiffLog/allocator.tsx"
    },
    "/test-payment-link/$invoiceId": {
      "filePath": "test-payment-link.$invoiceId.tsx"
    },
    "/timeoff/$timeOffRequestId": {
      "filePath": "timeoff.$timeOffRequestId.tsx"
    },
    "/timesheet/$timesheetOwnerId": {
      "filePath": "timesheet.$timesheetOwnerId.tsx"
    },
    "/toolFundCatalog/$catalogItemId": {
      "filePath": "toolFundCatalog/$catalogItemId.tsx"
    },
    "/toolLog/$toolLogOwnerId": {
      "filePath": "toolLog/$toolLogOwnerId.tsx"
    },
    "/tools/nitrogen": {
      "filePath": "tools.nitrogen.tsx",
      "parent": "/tools"
    },
    "/travel-estimate/$jobNumber": {
      "filePath": "travel-estimate.$jobNumber.tsx"
    },
    "/calendar/": {
      "filePath": "calendar/index.tsx"
    },
    "/customers/": {
      "filePath": "customers/index.tsx"
    },
    "/employees/": {
      "filePath": "employees/index.tsx"
    },
    "/hrDashboard/": {
      "filePath": "hrDashboard/index.tsx"
    },
    "/jobs/": {
      "filePath": "jobs/index.tsx"
    },
    "/memberships/": {
      "filePath": "memberships/index.tsx"
    },
    "/notes/": {
      "filePath": "notes/index.tsx"
    },
    "/payroll/": {
      "filePath": "payroll/index.tsx"
    },
    "/properties/": {
      "filePath": "properties/index.tsx"
    },
    "/reports/": {
      "filePath": "reports/index.tsx",
      "parent": "/reports"
    },
    "/spiffLog/": {
      "filePath": "spiffLog/index.tsx"
    },
    "/toolFundCatalog/": {
      "filePath": "toolFundCatalog/index.tsx"
    },
    "/toolLog/": {
      "filePath": "toolLog/index.tsx"
    },
    "/departments/edit/$functionId": {
      "filePath": "departments.edit.$functionId.tsx",
      "parent": "/departments"
    },
    "/documents/invoices/$invoiceId": {
      "filePath": "documents.invoices.$invoiceId.tsx",
      "parent": "/documents"
    },
    "/employees/items/options": {
      "filePath": "employees/items.options.tsx"
    },
    "/hrDashboard/newFire/create": {
      "filePath": "hrDashboard/newFire.create.tsx"
    },
    "/hrDashboard/newHire/create": {
      "filePath": "hrDashboard/newHire.create.tsx"
    },
    "/stripe/success/$token": {
      "filePath": "stripe.success.$token.tsx"
    },
    "/user/time-off/$userId": {
      "filePath": "user.time-off.$userId.tsx"
    },
    "/customers/$userId/properties/$propertyId": {
      "filePath": "customers/$userId.properties.$propertyId.tsx"
    },
    "/hrDashboard/newFire/edit/$userId": {
      "filePath": "hrDashboard/newFire.edit.$userId.tsx"
    },
    "/hrDashboard/newHire/edit/$newHireId": {
      "filePath": "hrDashboard/newHire.edit.$newHireId.tsx"
    },
    "/permitAdmin/$permitGroupId/permits/$permitId": {
      "filePath": "permitAdmin.$permitGroupId.permits.$permitId.tsx",
      "parent": "/permitAdmin/$permitGroupId"
    }
  }
}
ROUTE_MANIFEST_END */
